/**
 * Vietnamese localization
 */
export default {
  pipeline: {
    constructor: {
      title: 'Trình tạo Kanban',
      subtitle: 'Cấu hình các giai đoạn phễu và nhiệm vụ bắt buộc cho mỗi giai đoạn',
      reset: 'Đặt lại',
      save: 'Lưu phễu',
      saved: 'Đã lưu phễu',
      color: 'Màu',
      newStage: 'Giai đoạn mới',
      stageName: 'Tên giai đoạn',
      stageNamePlaceholder: 'Ví dụ: Đã lên lịch thuyết trình',
      stageType: 'Loại giai đoạn',
      terminalHint: '«Thắng» và «Thua» là giai đoạn cuối, đóng giao dịch (thắng / thua kèm lý do).',
      createStage: 'Tạo giai đoạn',
      typeNormal: 'Thường',
      typeWon: 'Thắng',
      typeLost: 'Thua',
      tasksCount: '{n} nhiệm vụ',
      wipLimit: 'Giới hạn thẻ (WIP)',
      mandatory: 'Bắt buộc',
      optional: 'Tùy chọn',
      overdueIn: 'Quá hạn sau {d}',
      nDays: '{n} ngày',
      nHours: '{n} giờ',
      addTask: 'Thêm nhiệm vụ',
      addStage: 'Thêm giai đoạn',
      deleteStage: {
        title: 'Xóa giai đoạn «{name}»?',
        protectedTitle: 'Không thể xóa giai đoạn «{name}»',
        protectedText:
          'Đây là giai đoạn hệ thống của phễu — được bảo vệ khỏi việc xóa và di chuyển.',
        protectedNote:
          'Giai đoạn khởi đầu «Chưa phân loại» và các giai đoạn cuối «Thắng» / «Thua» được bảo vệ để phễu luôn hợp lệ.',
        emptyText:
          'Giai đoạn không có giao dịch đang hoạt động — không có gì để chuyển. Giai đoạn và mẫu nhiệm vụ sẽ bị xóa.',
        reassignText:
          'Giai đoạn «{name}» có {count} giao dịch đang hoạt động. Chọn giai đoạn để chuyển — giai đoạn và mẫu nhiệm vụ sẽ bị xóa vĩnh viễn.',
        moveLabel: 'Chuyển {count} giao dịch sang giai đoạn',
        selectPlaceholder: 'Chọn giai đoạn',
        selectFirst: 'Hãy chọn giai đoạn trước',
        dealsShort: '{n} giao dịch | {n} giao dịch',
        summary: '{count} giao dịch sẽ chuyển sang «{target}»',
        templatesNote: 'Mẫu nhiệm vụ của giai đoạn ({n}) sẽ bị xóa.',
        reassignTemplatesNote:
          'Mẫu nhiệm vụ của giai đoạn ({n}) sẽ bị xóa. Các nhiệm vụ đã tạo trên giao dịch vẫn được giữ trong lịch sử.',
        confirm: 'Xóa giai đoạn',
        understood: 'Đã hiểu',
        movedToast: '{count} giao dịch đã chuyển sang «{target}»',
        deletedToast: 'Đã xóa giai đoạn',
      },
      loadError: 'Không tải được phễu',
      saveError: 'Không lưu được thay đổi',
    },
    taskEditor: {
      title: 'Nhiệm vụ giai đoạn',
      taskName: 'Tên nhiệm vụ',
      taskNamePlaceholder: 'Ví dụ: Thống nhất ngân sách và thời hạn',
      mandatory: 'Nhiệm vụ bắt buộc',
      mandatoryHint: 'Chặn chuyển giao dịch sang giai đoạn tiếp theo cho đến khi hoàn thành',
      deadline: 'Thời hạn',
      noDeadline: 'Không thời hạn',
      afterDeadline: 'Sau khoảng',
      hours: 'giờ',
      days: 'ngày',
      afterEnter: 'sau khi vào giai đoạn',
      priority: 'Ưu tiên',
      low: 'Thấp',
      medium: 'Trung bình',
      high: 'Cao',
      save: 'Lưu nhiệm vụ',
    },
    blocked: {
      modalTitle: 'Chuyển bị chặn',
      heading: 'Hãy hoàn thành các nhiệm vụ bắt buộc trước',
      body: 'Để chuyển giao dịch sang «{stage}», cần đóng các nhiệm vụ bắt buộc của giai đoạn hiện tại kèm ghi chú kết quả:',
      tasksLine: 'Chưa phải tất cả nhiệm vụ bắt buộc đã hoàn thành kèm ghi chú',
      openTask: 'Tới nhiệm vụ',
      openDeal: 'Mở giao dịch',
    },
  },
  common: {
    access: {
      forbiddenTitle: 'Mục không khả dụng',
      forbiddenDescription:
        'Vai trò của bạn không có quyền truy cập mục này. Nếu cần cho công việc, hãy liên hệ quản trị viên.',
      toDashboard: 'Về trang chính',
      noAccessTitle: 'Không có quyền vào CRM',
      noAccessDescription:
        'Tài khoản của bạn không thuộc ứng dụng này. Hãy đăng nhập bằng tài khoản làm việc hoặc liên hệ quản trị viên.',
      logout: 'Đăng xuất',
    },
    desktopOnly: {
      title: 'Màn hình này dành cho máy tính',
      description:
        'Màn hình cần màn hình rộng: trên điện thoại chỉ thấy một phần nhỏ và không thể làm việc được. Hãy mở mục này trên máy tính hoặc máy tính bảng xoay ngang.',
      back: 'Quay lại',
    },
    hints: {
      languageSettings: 'Đổi ngôn ngữ ở đây!',
    },
    unknownManager: 'Quản lý không xác định',
    table: {
      selected: 'Đã chọn: {count}',
      noData: 'Không có dữ liệu để hiển thị',
      noDataHint: 'Thử thay đổi bộ lọc hoặc thêm mục mới',
      actions: 'Thao tác',
    },
    actions: {
      create: 'Tạo mới',
      new: 'Mới',
      globalSearch: 'Tìm khách hàng, giao dịch, BĐS…',
      collapseSidebar: 'Thu gọn menu',
      openMenu: 'Mở menu',
      loadMore: 'Tải thêm',
      edit: 'Chỉnh sửa',
      delete: 'Xóa',
      save: 'Lưu',
      cancel: 'Hủy',
      confirm: 'Xác nhận',
      back: 'Quay lại',
      next: 'Tiếp theo',
      finish: 'Hoàn thành',
      search: 'Tìm kiếm',
      filter: 'Lọc',
      reset: 'Đặt lại',
      close: 'Đóng',
      add: 'Thêm',
      remove: 'Xóa',
      view: 'Xem',
      download: 'Tải xuống',
      upload: 'Tải lên',
      export: 'Xuất',
      import: 'Nhập',
      print: 'In',
      share: 'Chia sẻ',
      retry: 'Thử lại',
      clear: 'Xóa',
      apply: 'Áp dụng',
      all: 'Tất cả',
      yes: 'Có',
      no: 'Không',
    },
    globalSearch: {
      groups: {
        clients: 'Khách hàng',
        deals: 'Giao dịch',
        properties: 'Bất động sản',
      },
      hint: 'Bắt đầu nhập để tìm khách hàng, giao dịch và bất động sản',
      minChars: 'Nhập tối thiểu 2 ký tự',
      loading: 'Đang tìm…',
      empty: 'Không tìm thấy',
      emptyHint: 'Thử từ khóa khác',
      error: 'Tìm kiếm thất bại',
      navHint: 'điều hướng',
      openHint: 'mở',
      recent: 'Gần đây',
      newClient: 'Khách hàng mới',
      newDeal: 'Giao dịch mới',
    },
    calendar: {
      today: 'Hôm nay',
      weekDays: {
        mon: 'T2',
        tue: 'T3',
        wed: 'T4',
        thu: 'T5',
        fri: 'T6',
        sat: 'T7',
        sun: 'CN',
      },
      presets: {
        today: 'Hôm nay',
        last7Days: '7 ngày qua',
        thisMonth: 'Tháng này',
      },
    },
    views: {
      table: 'Bảng',
      kanban: 'Kanban',
    },
    labels: {
      name: 'Tên',
      description: 'Mô tả',
      date: 'Ngày',
      status: 'Trạng thái',
      type: 'Loại',
      price: 'Giá',
      address: 'Địa chỉ',
      city: 'Thành phố',
      country: 'Quốc gia',
      phone: 'Điện thoại',
      email: 'Email',
      notes: 'Ghi chú',
      comments: 'Bình luận',
      createdAt: 'Ngày tạo',
      updatedAt: 'Ngày cập nhật',
      theme: 'Chủ đề',
      lightTheme: 'Chủ đề sáng',
      darkTheme: 'Chủ đề tối',
      notifications: 'Thông báo',
      noResults: 'Không tìm thấy kết quả',
      search: 'Tìm kiếm',
      yes: 'Có',
      no: 'Không',
      other: 'Khác',
    },
    messages: {
      loading: 'Đang tải...',
      noData: 'Không có dữ liệu',
      error: 'Đã xảy ra lỗi',
      success: 'Thành công',
      confirmDelete: 'Bạn có chắc chắn muốn xóa?',
      requiredField: 'Trường này là bắt buộc',
      invalidEmail: 'Email không hợp lệ',
      invalidPhone: 'Số điện thoại không hợp lệ',
    },
    errors: {
      loadingFailed: 'Tải thất bại',
      saveFailed: 'Lưu thất bại',
      deleteFailed: 'Xóa thất bại',
      networkError: 'Lỗi mạng',
      unauthorized: 'Yêu cầu đăng nhập',
      forbidden: 'Truy cập bị từ chối',
      notFound: 'Không tìm thấy',
      serverError: 'Lỗi máy chủ',
    },
    navigation: {
      partnerCompanies: 'Công ty đối tác',
      notifications: 'Thông báo',
      home: 'Trang chủ',
      dashboard: 'Bảng điều khiển',
      profile: 'Hồ sơ',
      clients: 'Khách hàng',
      agents: 'Đại lý',
      agentsRegistry: 'Danh sách đại lý',
      moderation: 'Kiểm duyệt',
      analytics: 'Phân tích',
      properties: 'Bất động sản',
      projectsSection: 'Quản lý dự án',
      projectsList: 'Dự án',
      projectsImport: 'Nhập dự án',
      deals: 'Giao dịch',
      calendar: 'Lịch',
      reports: 'Báo cáo',
      settings: 'Cài đặt',
      tools: 'Công cụ',
      calls: 'Cuộc gọi',
      documents: 'Tài liệu',
      system: 'Hệ thống',
      managerAnalytics: 'Phân tích quản lý',
      routingRules: 'Định tuyến',
      pipelineConstructor: 'Trình tạo phễu',
      personalSettings: 'Cài đặt cá nhân',
      administration: 'Quản trị',
    },
    pagination: {
      showing: 'Hiển thị {count} / {total}',
      page: 'Trang {current} / {total}',
      previous: 'Trước',
      next: 'Tiếp',
    },
  },
  history: {
    loading: 'Đang tải lịch sử…',
    loadMore: 'Tải thêm',
    taskBadge: 'Nhiệm vụ',
    openTasks: 'Tới nhiệm vụ',
    taskResult: 'Kết quả: {result}',
    filters: {
      action: 'Loại hành động',
      allActions: 'Tất cả hành động',
      actor: 'Tác giả',
      allActors: 'Tất cả tác giả',
      period: 'Khoảng thời gian',
    },
    empty: {
      title: 'Chưa có lịch sử',
      description: 'Chưa có thay đổi nào',
    },
    actions: {
      created: 'Tạo mới',
      updated: 'Cập nhật',
      deleted: 'Xóa',
      manager_changed: 'Đổi quản lý',
      note_added: 'Thêm ghi chú',
      contact_added: 'Thêm liên hệ',
      contact_removed: 'Xóa liên hệ',
      task_created: 'Tạo nhiệm vụ',
      task_updated: 'Cập nhật nhiệm vụ',
      task_completed: 'Hoàn thành nhiệm vụ',
      task_auto_closed: 'Nhiệm vụ đã đóng tự động',
      task_deleted: 'Xóa nhiệm vụ',
      file_uploaded: 'Tải lên tệp',
      file_downloaded: 'Tải xuống tệp',
      stage_changed: 'Đổi giai đoạn',
      status_changed: 'Đổi trạng thái',
      closed: 'Đóng',
      commission_paid: 'Đã trả hoa hồng',
      comment_added: 'Thêm bình luận',
    },
  },
  clients: {
    contactsList: {
      primary: 'Chính',
      empty: 'Chưa có liên hệ',
      add: 'Thêm liên hệ',
      valuePlaceholder: 'Giá trị',
    },
    title: 'Khách hàng',
    subtitle: 'Quản lý cơ sở dữ liệu khách hàng',
    listSubtitle: 'Quản lý cơ sở dữ liệu khách hàng · {count} liên hệ',
    notAssigned: 'Chưa phân công',
    bulkDelete: { confirm: 'Xóa {count} khách hàng?' },
    newClient: 'Khách hàng mới',
    searchPlaceholder: 'Tìm kiếm theo tên, điện thoại, email...',
    create: 'Tạo khách hàng',
    edit: 'Chỉnh sửa khách hàng',
    details: 'Chi tiết khách hàng',
    list: 'Danh sách khách hàng',
    noManager: 'Không có quản lý',
    stats: {
      total: 'Tổng số khách hàng',
      newThisMonth: 'Mới tháng này',
      activeDeals: 'Giao dịch hoạt động',
      allTime: 'tất cả thời gian',
      vsPrevMonth: 'so với tháng trước',
      withDeal: 'Có giao dịch',
      withDealCaption: 'giao dịch hoạt động',
      unassigned: 'Chưa phân công',
      unassignedCaption: 'cần phân bổ',
    },
    filters: {
      title: 'Bộ lọc',
      stage: 'Giai đoạn',
      allStages: 'Tất cả giai đoạn',
      allSources: 'Tất cả nguồn',
      sourceTree: {
        utmSource: 'Nhãn: {value}',
      },
      allCities: 'Tất cả thành phố',
      allLanguages: 'Tất cả ngôn ngữ',
      allDealStatuses: 'Tất cả',
      allManagers: 'Tất cả quản lý',
      withDeal: 'Có giao dịch',
      withoutDeal: 'Không có giao dịch',
      dealStatus: 'Trạng thái giao dịch',
      manager: 'Quản lý',
      allAgents: 'Tất cả đại lý',
      agent: 'Đại lý',
      createdAt: 'Ngày tạo',
      createdAtPlaceholder: 'Chọn khoảng thời gian',
      active: 'Bộ lọc hoạt động',
      clearAll: 'Xóa tất cả',
      reset: 'Đặt lại bộ lọc',
      tag: 'Thẻ',
      allTags: 'Tất cả thẻ',
      archiveReason: 'Lý do lưu trữ',
      allArchiveReasons: 'Tất cả lý do',
    },
    presets: {
      aria: 'Bộ lọc nhanh danh sách khách hàng',
      all: 'Tất cả',
      mine: 'Của tôi',
      unassigned: 'Chưa có người phụ trách',
      agents: 'Qua đại lý',
      duplicates: 'Trùng lặp',
    },
    duplicatesBlock: {
      title: 'Khách trùng từ đại lý',
      viewAll: 'Tất cả trùng lặp ({n})',
    },
    export: {
      csv: 'CSV (bảng)',
      xlsx: 'Excel (XLSX)',
    },
    import: {
      uploadFile: 'Tải tệp lên',
      downloadTemplate: 'Tải mẫu CSV',
      invalidFormat: 'Chỉ hỗ trợ tệp CSV và XLSX',
      failedToast: 'Không thể nhập khách hàng',
      resultTitle: 'Kết quả nhập',
      summary: 'Số dòng đã xử lý: {total}',
      created: 'Đã tạo: {count}',
      merged: 'Đã bổ sung: {count}',
      skipped: 'Đã bỏ qua: {count}',
      failed: 'Lỗi: {count}',
      errorsTitle: 'Lỗi theo dòng',
      line: 'Dòng {line}',
    },
    table: {
      client: 'Khách hàng',
      contact: 'Liên hệ',
      interest: 'Mục đích',
      budget: 'Ngân sách',
      timeline: 'Thời hạn',
      manager: 'Quản lý',
      createdAt: 'Ngày tạo',
    },
    actions: {
      changeStatus: 'Thay đổi trạng thái',
      addClient: 'Thêm khách hàng',
      createClient: 'Tạo khách hàng',
      retry: 'Thử lại',
      addNote: 'Thêm ghi chú',
      bulkUpdate: 'Cập nhật hàng loạt',
      assignManager: 'Chỉ định quản lý',
    },
    bulkUpdate: {
      title: 'Cập nhật hàng loạt khách hàng',
      description: 'Khách hàng đã chọn: {count}. Chỉ định các trường cần cập nhật.',
      newStage: 'Giai đoạn mới',
      newManager: 'Quản lý mới',
      keepCurrent: 'Giữ nguyên',
      archiveClients: 'Lưu trữ khách hàng',
      success: 'Đã cập nhật khách hàng: {count}',
      error: 'Lỗi cập nhật hàng loạt',
      noChanges: 'Chọn ít nhất một trường để cập nhật',
    },
    archive: {
      archive: 'Lưu trữ',
      unarchive: 'Hủy lưu trữ',
      confirmArchive: 'Bạn có chắc chắn muốn lưu trữ khách hàng này không?',
      cascadeHint:
        'Các giao dịch đang hoạt động của khách hàng sẽ được đóng là Đã đóng và không thực hiện, các nhiệm vụ đang mở của khách hàng và giao dịch sẽ bị gỡ bỏ.',
      revivedOnCreate:
        'Khách hàng với thông tin liên hệ này đã được lưu trữ — thẻ đã được khôi phục',
      confirmUnarchive: 'Bạn có chắc chắn muốn hủy lưu trữ khách hàng này không?',
      successArchived: 'Đã lưu trữ khách hàng',
      successUnarchived: 'Đã hủy lưu trữ khách hàng',
      error: 'Lỗi khi lưu trữ khách hàng',
      archivedAt: 'Đã lưu trữ',
      archivedBadge: 'Đã lưu trữ',
      reason: 'Lý do lưu trữ',
      reasonPlaceholder: 'Chỉ định lý do lưu trữ...',
      reasonRequired: 'Vui lòng chỉ định lý do lưu trữ',
      reasonSelectPlaceholder: 'Chọn lý do',
      comment: 'Bình luận',
      commentPlaceholder: 'Chi tiết đóng (không bắt buộc)...',
    },
    tags: {
      add: 'Gắn thẻ',
      remove: 'Bỏ thẻ',
    },
    detail: {
      noContacts: 'Chưa chỉ định liên hệ',
      preferredContactMethod: 'Phương thức liên hệ ưu tiên',
      firstContactDate: 'Ngày liên hệ đầu tiên',
      responsibleManager: 'Người quản lý chịu trách nhiệm',
      call: 'Gọi điện',
      write: 'Nhắn tin',
      tasks: {
        title: 'Nhiệm vụ',
        add: 'Thêm nhiệm vụ',
        edit: 'Sửa nhiệm vụ',
        empty: 'Chưa có nhiệm vụ',
        assigneeDefault: 'Người quản lý chịu trách nhiệm khách hàng (mặc định)',
        confirmDelete: 'Xóa nhiệm vụ này?',
      },
      agent: 'Đại lý',
      agentSource: {
        channel: 'Kênh thu hút',
        sourceTypes: {
          Agent: 'Đại lý',
          Direct: 'Trực tiếp',
          Marketing: 'Marketing',
          Referral: 'Giới thiệu',
          Other: 'Khác',
        },
        company: 'Công ty',
        openCompany: 'Mở công ty',
        model: 'Mô hình',
        special: 'Đặc biệt',
        duplicate: 'Trùng lặp',
        duplicateStatuses: {
          not_checked: 'Chưa kiểm tra',
          duplicate_pending: 'Nghi trùng lặp',
          duplicate_confirmed: 'Đã xác nhận trùng',
          rejected: 'Từ chối',
        },
        comment: 'Ghi chú của đại lý',
        // DEV-1918. Kênh thu hút / đại lý (ClientSourceField).
        gateHint: 'Chỉ ADMIN, HOS, CEO thay đổi',
        noAgent: 'Chưa chỉ định đại lý',
        setAgent: 'Chỉ định đại lý',
        mismatch: 'kênh không khớp',
        mismatchHint:
          'Khách hàng có đại lý nhưng kênh thu hút không phải «Đại lý». Đổi kênh sang «Đại lý» sẽ khắc phục.',
        changeAgent: 'Đổi đại lý',
        openAgent: 'Mở đại lý',
        details: 'Chi tiết',
        registeredAt: 'Đại lý đăng ký',
        duplicateReason: 'Lý do trùng lặp',
        panelRequest: 'Yêu cầu từ panel',
        saving: 'Đang lưu…',
        cancelHint: 'khôi phục kênh cũ, chưa lưu gì',
        picker: {
          placeholder: 'Tìm đại lý theo tên hoặc số điện thoại…',
          empty: 'Không tìm thấy đại lý',
          error: 'Không tải được danh sách đại lý',
          scopeHint: 'Hiển thị đại lý trong khu vực của bạn',
        },
        confirm: {
          assignTitle: 'Chỉ định đại lý?',
          assignDescription: '{agent} sẽ là đại lý của khách hàng, kênh thu hút — «Đại lý».',
          assign: 'Chỉ định',
          assignImpact: 'Ghi nhận và hoa hồng đại lý sẽ chuyển sang {n} giao dịch đang mở.',
          changeTitle: 'Đổi đại lý?',
          changeDescription: 'Đại lý sẽ thay đổi: {old} → {new}.',
          change: 'Đổi',
          changeImpact: 'Ghi nhận của {n} giao dịch đang mở sẽ chuyển sang đại lý mới.',
          removeTitle: 'Gỡ đại lý?',
          removeDescription:
            '{agent} sẽ không còn là đại lý của khách hàng, kênh thu hút trở thành «{channel}».',
          remove: 'Gỡ đại lý',
          removeImpact:
            'Ghi nhận và hoa hồng đại lý sẽ bị gỡ khỏi {n} giao dịch đang mở; không còn tính hoa hồng cho chúng.',
          noDeals: 'Không có giao dịch đang mở.',
          sync: 'Các giao dịch đang mở của khách hàng sẽ được đồng bộ.',
          dealsError: 'Không đếm được giao dịch đang mở.',
          dealsRetry: 'Đếm lại',
        },
        toast: {
          assigned: 'Đã chỉ định đại lý',
          changed: 'Đã đổi đại lý',
          removed: 'Đã gỡ đại lý',
          channelUpdated: 'Đã cập nhật kênh thu hút',
          syncPending: 'Giao dịch sẽ cập nhật trong một phút',
        },
      },
      // DEV-1918. Thẻ khách hàng v2: tiêu đề «Nhóm & ghi nhận» và các thẻ bên trong.
      attribution: { leads: 'PHỤ TRÁCH', broughtBy: 'GIỚI THIỆU BỞI', heardFrom: 'BIẾT ĐẾN TỪ' },
      entryPoints: 'Điểm vào',
      loadError: 'Không tải được khách hàng',
      inCrmSince: 'trong CRM từ {date}',
      responsibleShort: 'Phụ trách: {name}',
      note: 'Ghi chú',
      focus: { title: 'Trọng tâm', overdue: 'quá hạn {n}', more: 'thêm {n}' },
      qualification: {
        title: 'Đánh giá nhu cầu',
        subtitle: 'ngân sách, mục tiêu, thời hạn, tiêu chí',
        financing: 'Tài chính',
      },
      profile: {
        title: 'Hồ sơ',
        meta: 'Tạo {created} · cập nhật {updated} · id {id}',
        copyId: 'Sao chép id',
        copied: 'Đã sao chép',
      },
      team: {
        title: 'Nhóm & ghi nhận',
        notAssigned: 'Chưa chỉ định',
        assignSelf: 'Tự nhận',
        impact:
          'Người phụ trách thay đổi ở khách hàng — mọi giao dịch đang hoạt động của khách này ({n}) chuyển sang quản lý mới.',
        managersHistory: 'Lịch sử quản lý',
      },
      tasksCard: {
        updateError: 'Không thể cập nhật nhiệm vụ',
        add: 'Nhiệm vụ',
        mandatory: 'Bắt buộc',
        noDue: 'không có hạn',
        client: 'khách hàng',
        showAll: 'hiện tất cả ({n})',
        collapse: 'thu gọn',
        completed: 'đã hoàn thành ({n})',
        empty: 'Không có nhiệm vụ',
        openDeal: 'Mở giao dịch',
      },
      dealsCard: {
        title: 'Giao dịch',
        add: 'Giao dịch',
        current: 'hiện tại',
        all: 'tất cả ({n})',
        collapse: 'thu gọn',
        empty: 'Chưa có giao dịch',
        mandatory: '{done}/{total} bắt buộc',
      },
      feed: {
        title: 'Dòng thời gian',
        placeholder: 'Viết ghi chú…',
        important: 'Quan trọng',
        add: 'Thêm',
        note: 'ghi chú',
        interaction: 'tương tác',
        more: 'thêm ({n})',
        empty: 'Chưa có gì',
      },
      contactsCard: {
        empty: 'Chưa có liên hệ',
        add: 'Thêm',
        newsletter: 'Bản tin',
        telegramBot: 'Bot Telegram',
        openChat: 'Nhắn qua {provider}',
        email: 'Gửi email',
        mismatch: '≠ ở giao dịch',
        mismatchHint:
          'Ghi nhận của giao dịch được cố định khi tạo. Đại lý hiện tại của khách — {agent}. Chỉ có thể đổi trong thẻ khách hàng.',
        editAtClient: 'Đổi ở khách hàng',
        channelAgent: 'Kênh · đại lý',
        noPhone: 'Không có số điện thoại',
        budget: 'Ngân sách',
        loadError: 'Không tải được liên hệ',
      },
      you: 'bạn',
      assignSelf: 'Tự nhận làm người phụ trách',
      assignSelfConfirmTitle: 'Tiếp nhận khách hàng này?',
      assignSelfConfirmDescription:
        'Người phụ trách hiện tại: {manager}. Bạn có muốn tự nhận làm người phụ trách không?',
      currentDeal: 'Giao dịch hiện tại',
      expectedCommission: 'Hoa hồng dự kiến',
      paymentStatus: 'Trạng thái thanh toán',
      fundingType: 'Loại tài trợ',
      documents: 'Tài liệu',
      stageTasks: 'Công việc giai đoạn',
      addTask: 'Thêm công việc',
      pending: 'chưa hoàn thành',
      noTasksForStage: 'Không có công việc cho giai đoạn này',
      addFirstTask: 'Thêm công việc đầu tiên',
      stageBlockedWarning: 'Công việc chưa hoàn thành sẽ chặn chuyển sang giai đoạn tiếp theo',
      taskDescription: 'Mô tả công việc',
      taskDescriptionPlaceholder: 'Nhập mô tả công việc...',
      taskPriority: 'Mức độ ưu tiên',
      taskDueDate: 'Hạn chót',
      changeHistory: 'Lịch sử thay đổi',
      noChanges: 'Không có lịch sử',
      loadMore: 'Tải thêm',
      files: 'Tệp',
    },
    changeAction: {
      CREATED: 'Khách hàng đã tạo',
      UPDATED: 'Dữ liệu đã cập nhật',
      STAGE_CHANGED: 'Giai đoạn đã thay đổi',
      STATUS_CHANGED: 'Trạng thái đã thay đổi',
      TASK_CREATED: 'Công việc đã tạo',
      TASK_UPDATED: 'Công việc đã cập nhật',
      TASK_COMPLETED: 'Công việc đã hoàn thành',
      TASK_DELETED: 'Công việc đã xóa',
      NOTE_ADDED: 'Ghi chú đã thêm',
      NOTE_UPDATED: 'Ghi chú đã cập nhật',
      NOTE_DELETED: 'Ghi chú đã xóa',
      MANAGER_ASSIGNED: 'Quản lý đã chỉ định',
      CONTACT_ADDED: 'Liên hệ đã thêm',
      CONTACT_REMOVED: 'Liên hệ đã xóa',
      DELETED: 'Khách hàng đã xóa',
    },
    tabs: {
      overview: 'Tổng quan',
      calls: 'Cuộc gọi',
      files: 'Tệp',
      history: 'Lịch sử',
      chats: 'Trò chuyện',
    },
    emptyState: {
      title: 'Không tìm thấy khách hàng',
      noClients: 'Bắt đầu bằng cách thêm khách hàng đầu tiên',
      withFilters: 'Thử thay đổi bộ lọc để tìm khách hàng',
    },
    stageRequirements: {
      title: 'Yêu cầu giai đoạn',
      remaining: 'còn lại',
      allComplete: 'Hoàn tất',
      fill: 'Điền',
      warning: 'Điền tất cả các trường để chuyển sang giai đoạn "{stage}"',
      readyToAdvance: 'Sẵn sàng chuyển sang giai đoạn "{stage}"',
    },
    form: {
      personalInfo: 'Thông tin cá nhân',
      firstName: 'Tên',
      lastName: 'Họ',
      dateOfBirth: 'Ngày sinh',
      language: 'Ngôn ngữ',
      contacts: 'Liên hệ',
      addContact: 'Thêm liên hệ',
      addContactPlaceholder: 'Thêm ít nhất một liên hệ',
      noContacts: 'Chưa có liên hệ nào được thêm. Nhấp vào nút trên để thêm liên hệ.',
      contactType: 'Loại liên hệ',
      contactValue: 'Giá trị',
      preferredContact: 'Phương thức liên hệ ưu tiên',
      clientStatus: 'Trạng thái khách hàng',
      leadSource: 'Nguồn khách hàng',
      // DEV-699. Опциональный выбор ответственного при создании клиента.
      managerOptionalAuto: 'Phân bổ tự động',
      managerOptionalHint: 'Nếu không chọn người quản lý, khách hàng sẽ được phân bổ tự động',
      interests: 'Sở thích và nhu cầu',
      propertyTypes: 'Loại bất động sản',
      locations: 'Vị trí',
      budget: 'Ngân sách',
      budgetMin: 'Tối thiểu',
      budgetMax: 'Tối đa',
      currency: 'Tiền tệ',
      purchaseGoal: 'Mục đích mua',
      dealTimeline: 'Thời hạn mua',
      cityInterest: 'Thành phố quan tâm',
      additionalCriteria: 'Tiêu chí bổ sung',
      additionalInfo: 'Thông tin bổ sung',
      comment: 'Bình luận',
      subscribeNewsletter: 'Đăng ký nhận bản tin',
      preview: 'Xem trước',
      selectCountry: 'Chọn quốc gia',
      selectStatus: 'Chọn trạng thái',
      selectSource: 'Chọn nguồn',
      enterCity: 'Nhập thành phố',
      enterCityName: 'Nhập tên thành phố',
      enterLocation: 'Nhập vị trí và nhấn Enter',
      enterCriteria: 'Nhập tiêu chí và nhấn Enter',
      from: 'Từ',
      to: 'Đến',
      notSpecified: 'Không xác định',
      commentPlaceholder: 'Thông tin bổ sung về khách hàng...',
      checkData: 'Kiểm tra dữ liệu đã nhập trước khi tạo',
      selectDate: 'Chọn ngày',
      errors: {
        required: 'Trường này là bắt buộc',
        invalidEmail: 'Địa chỉ email không hợp lệ',
        invalidPhone: 'Số điện thoại không hợp lệ',
      },
    },
    wizard: {
      step1: 'Cơ bản',
      step1Desc: 'Tên, ngôn ngữ, nguồn',
      step2: 'Liên hệ',
      step2Desc: 'Điện thoại, email, kênh',
      step3: 'Ngân sách',
      step3Desc: 'Mục tiêu, ngân sách, tài chính',
      step4: 'Hoàn tất',
      step4Desc: 'Phụ trách, thẻ',
      stepOf: 'Bước {current} / {total}',
      subtitle: 'Điền hồ sơ khách hàng theo từng bước',
      stepsCap: 'CÁC BƯỚC',
      responsible: 'Người phụ trách',
      create: 'Tạo khách hàng',
    },
    propertyTypes: {
      apartment: 'Căn hộ',
      villa: 'Biệt thự',
      townhouse: 'Nhà phố',
      land: 'Đất',
      commercial: 'Thương mại',
    },
    contactTypes: {
      email: 'Email',
      phone: 'Điện thoại',
      telegram: 'Telegram',
      whatsapp: 'WhatsApp',
      other: 'Khác',
    },
    enums: {
      contactType: {
        phone: 'Điện thoại',
        email: 'Email',
        whatsapp: 'WhatsApp',
        telegram: 'Telegram',
        other: 'Khác',
      },
      propertyType: {
        apartments: 'Căn hộ',
        villas: 'Biệt thự',
        commercial: 'Thương mại',
      },
      purchaseGoal: {
        investment: 'Bán lại',
        living: 'Để ở',
        rental: 'Cho thuê',
      },
      dealTimeline: {
        urgent: 'Gấp',
        threeToSixMonths: '3–6 tháng',
        moreThanSixMonths: 'Hơn 6 tháng',
      },
      paymentStatus: {
        deposit: 'Đặt cọc',
        advance: 'Trả trước',
        fullPayment: 'Thanh toán đầy đủ',
      },
      fundingType: {
        mortgage: 'Vay thế chấp',
        installment: 'Trả góp',
        cash: 'Tiền mặt',
      },
      originEntityType: {
        article: 'Bài viết',
        residentialComplex: 'Khu dân cư',
      },
      priority: {
        low: 'Thấp',
        medium: 'Trung bình',
        high: 'Cao',
      },
    },
    // DEV-42: clients.stages và clients.kanban đã bị loại bỏ.
  },
  properties: {
    title: 'Dự án',
    objects: 'đối tượng',
    addProperty: 'Thêm bất động sản',
    addComplex: 'Thêm dự án',
    addComplexHint: 'Tạo dự án trong trang quản trị',
    listSubtitle: 'Danh mục bất động sản · {complexes} dự án · {drafts} bản nháp',
    found: 'Tìm thấy {count} bất động sản',
    selected: 'Đã chọn: {count} bất động sản',
    searchPlaceholder: 'Tìm kiếm theo tên dự án...',
    statusFilter: {
      all: 'Tất cả',
      published: 'Đã xuất bản',
      drafts: 'Bản nháp',
    },
    create: 'Tạo bất động sản',
    edit: 'Chỉnh sửa bất động sản',
    details: 'Chi tiết bất động sản',
    list: 'Danh sách bất động sản',
    views: {
      aria: 'Chế độ hiển thị',
      grid: 'Lưới',
      list: 'Danh sách',
      map: 'Bản đồ',
    },
    featureChips: {
      foreigners: 'Cho người nước ngoài',
      pinkBook: 'Sổ hồng',
      video: 'Video',
      docsChecked: 'Đã kiểm tra giấy tờ',
    },
    // DEV-1003: hiển thị dự án cho đại lý (công tắc trong «Đối tượng», admin/hos)
    agentAvailability: {
      badge: 'Dành cho đại lý',
      toggle: 'Hiển thị cho đại lý',
      enabled: 'Đã mở dự án cho đại lý',
      disabled: 'Đã ẩn dự án khỏi đại lý',
      error: 'Không thể thay đổi trạng thái hiển thị',
    },
    stats: {
      total: 'Tổng số dự án',
      inSale: 'Căn đang bán',
      featured: 'Nổi bật',
      developers: 'Chủ đầu tư',
      pending: 'đang cập nhật',
      newThisMonth: 'Mới tháng này',
    },
    sort: {
      name: 'Theo tên',
      priceAsc: 'Giá: Thấp đến cao',
      priceDesc: 'Giá: Cao đến thấp',
      area: 'Theo diện tích',
      date: 'Theo ngày thêm',
    },
    actions: {
      compare: 'So sánh',
      clearFilters: 'Xóa bộ lọc',
      addFirst: 'Thêm bất động sản đầu tiên',
      downloadPresentation: 'Tải PDF',
      generatePresentation: 'Tạo PDF',
      generatingPresentation: 'Đang tạo...',
      regeneratePresentation: 'Tạo lại',
    },
    emptyState: {
      title: 'Không tìm thấy bất động sản',
      subtitle: 'Thử thay đổi tham số tìm kiếm hoặc bộ lọc',
    },
    compare: {
      title: 'So sánh bất động sản',
      instruction: 'Chọn từ 2 đến 4 bất động sản để so sánh',
    },
    confirm: {
      delete: 'Xóa {count} bất động sản?',
    },
    tags: {
      recommended: 'Đề xuất',
    },
    noResults: 'Không tìm thấy bất động sản',
    roomsCount: '{count} phòng',
    types: {
      apartment: 'Căn hộ',
      villa: 'Biệt thự',
      townhouse: 'Nhà phố',
      commercial: 'Thương mại',
    },
    objectTypes: {
      OBJECT_TYPE_APARTMENT: 'Căn hộ',
      OBJECT_TYPE_STUDIO: 'Studio',
      OBJECT_TYPE_PENTHOUSE: 'Penthouse',
      OBJECT_TYPE_VILLA: 'Biệt thự',
      OBJECT_TYPE_TOWNHOUSE: 'Nhà phố',
      OBJECT_TYPE_DUPLEX: 'Duplex',
      OBJECT_TYPE_CONDOTEL: 'Condotel',
      OBJECT_TYPE_SHOPHOUSE: 'Shophouse',
      OBJECT_TYPE_OFFICE: 'Văn phòng',
      OBJECT_TYPE_RETAIL: 'Bán lẻ',
      OBJECT_TYPE_LAND: 'Đất',
    },
    filters: {
      searchByName: 'Tìm kiếm theo tên...',
      projectType: 'Loại dự án',
      type: 'Loại',
      city: 'Thành phố',
      priceFrom: 'Giá từ',
      priceTo: 'đến',
      moreFilters: 'Thêm bộ lọc',
      hideFilters: 'Ẩn bộ lọc',
      location: 'Vị trí',
      cities: 'Thành phố',
      additional: 'Bổ sung',
      featured: 'Nổi bật',
      visibility: 'Hiển thị',
      projectRank: 'Hạng dự án',
      amenities: 'Tiện ích',
      features: 'Đặc điểm',
      apply: 'Áp dụng bộ lọc',
      drawer: {
        title: 'Bộ lọc',
        reset: 'Đặt lại',
        priceRange: 'Giá, ₫',
        showResults: 'Hiển thị {count} dự án',
      },
      chips: {
        search: 'Tìm kiếm',
        type: 'Loại',
        rooms: 'Phòng',
        rank: 'Hạng',
        amenities: 'Tiện ích',
        features: 'Đặc điểm',
      },
    },
    map: {
      complexesOnMap: '{count} dự án trên bản đồ',
      sortByPrice: 'Theo giá',
      searchThisArea: 'Tìm trong khu vực này',
      loading: 'Đang tải bản đồ...',
    },
    card: {
      addToFavorites: 'Thêm vào yêu thích',
      removeFromFavorites: 'Xóa khỏi yêu thích',
      addToCompare: 'Thêm để so sánh',
      from: 'từ',
      priceOnRequest: 'Giá theo yêu cầu',
      objectsCount: '{count} loại căn',
      amenitiesCount: '{count} tiện ích',
      rooms: '{count} phòng',
      area: '{value} m²',
      floor: 'Tầng {floor}/{total}',
      year: 'Năm {year}',
      details: 'Chi tiết',
      downloadPresentation: 'Tải xuống bản trình bày',
      generatePresentation: 'Tạo bản trình bày',
    },
    status: {
      available: 'Có sẵn',
      reserved: 'Đã đặt trước',
      sold: 'Đã bán',
      new: 'Mới',
      hot: 'Nóng',
    },
    detail: {
      errorLoadingData: 'Không thể tải dữ liệu bất động sản',
      objectsInComplex: 'Đối tượng trong khu phức hợp',
      promos: 'Khuyến mãi',
      aboutObject: 'Về dự án',
      amenities: 'Tiện ích',
      highlights: 'Điểm nổi bật',
      documentsCheck: 'Kiểm tra giấy tờ',
      developer: 'Chủ đầu tư',
      files: 'Tệp & bản trình bày',
      location: 'Vị trí',
      downloadPresentation: 'Tải bản trình bày',
      // DEV-2249: trên điện thoại mô tả dự án và chủ đầu tư được thu gọn
      showFull: 'Xem đầy đủ',
      collapse: 'Thu gọn',
    },
    unitsTable: {
      type: 'Loại',
      rooms: 'Phòng',
      area: 'Diện tích',
      available: 'Còn trống',
      price: 'Giá',
    },
    amenityLabels: {
      AMENITY_BAR: 'Quầy bar',
      AMENITY_RESTAURANT: 'Nhà hàng',
      AMENITY_SPA: 'Spa',
      AMENITY_YOGA: 'Yoga',
      AMENITY_CONVENIENCE_STORE: 'Cửa hàng tiện lợi',
      AMENITY_SHOPPING_MALL: 'Trung tâm thương mại',
      AMENITY_SCHOOL: 'Trường học',
      AMENITY_KINDERGARTEN: 'Mẫu giáo',
      AMENITY_COLLEGE: 'Cao đẳng',
      AMENITY_SWIMMING_POOL: 'Hồ bơi',
      AMENITY_KIDS_PLAYGROUND: 'Khu vui chơi trẻ em',
      AMENITY_GYM: 'Phòng gym',
      AMENITY_COMMUNITY_ROOM: 'Phòng sinh hoạt chung',
      AMENITY_JOGGING_PATH: 'Đường chạy bộ',
      AMENITY_BBQ: 'Khu BBQ',
      AMENITY_GREEN_AREA: 'Khu vực xanh',
      AMENITY_TENNIS_COURT: 'Sân tennis',
      AMENITY_KIDS_POOL: 'Hồ bơi trẻ em',
      AMENITY_PARKING: 'Bãi đỗ xe',
      AMENITY_CAFE: 'Cà phê',
    },
    highlightLabels: {
      HIGHLIGHT_REPUTABLE_DEVELOPER: 'Chủ đầu tư uy tín',
      HIGHLIGHT_INSTALLMENT_PLAN: 'Trả góp',
      HIGHLIGHT_FULL_LEGAL_GROUND: 'Pháp lý đầy đủ',
      HIGHLIGHT_FREE_HIGH_APPRECIATION_POTENTIAL: 'Tiềm năng tăng giá cao',
    },
    documentLabels: {
      DEVELOPERS_DOCUMENTS_CHECKING_CONSTRUCTION_PERMIT: 'Giấy phép xây dựng',
      DEVELOPERS_DOCUMENTS_CHECKING_LAND_USE_RIGHT_CERTIFICATE: 'Giấy chứng nhận quyền sử dụng đất',
      DEVELOPERS_DOCUMENTS_CHECKING_BANK_LETTER_OF_GUARANTEE: 'Thư bảo lãnh ngân hàng',
      DEVELOPERS_DOCUMENTS_CHECKING_SALE_PERMIT: 'Giấy phép bán hàng',
      DEVELOPERS_DOCUMENTS_CHECKING_SALE_PERMIT_FOR_FOREIGNERS:
        'Giấy phép bán cho người nước ngoài',
    },
    quickInfo: {
      published: 'Đã xuất bản',
      hidden: 'Ẩn',
      featured: 'Nổi bật',
      minPrice: 'Giá tối thiểu',
      blocks: 'tòa nhà',
      objectTypes: 'loại đối tượng',
      handover: 'bàn giao',
      promos: 'khuyến mãi',
      objectTypesTitle: 'Loại Đối Tượng',
      created: 'Tạo',
      updated: 'Cập nhật',
      developer: 'Nhà phát triển',
      goToDeveloper: 'Đi đến nhà phát triển',
    },
    tabs: {
      overview: 'Tổng quan',
      locationTab: 'Vị trí',
      developerTab: 'Nhà phát triển',
      documentsTab: 'Tài liệu',
      description: 'Mô tả',
      features: 'Đặc điểm',
      amenities: 'Tiện ích',
      projectHighlights: 'Điểm nổi bật của dự án',
      location: 'Vị trí',
      noLocation: 'Không chỉ định vị trí',
      projectsCount: '{count} dự án',
      since: 'Từ {year}',
      rating: 'Đánh giá {value}',
      allDeveloperProjects: 'Tất cả dự án của nhà phát triển',
      verifiedDocuments: 'Tài liệu đã xác minh',
      noDocuments: 'Thông tin tài liệu không khả dụng',
    },
  },
  files: {
    source: {
      upload: 'Tải lên',
    },
    dropOrClick: 'Kéo tệp vào đây',
    orClickToSelect: 'hoặc nhấn để chọn',
    uploading: 'Đang tải lên...',
    loading: 'Đang tải tệp...',
    empty: 'Chưa có tệp nào',
    emptyDescription: 'Tải tệp lên bằng cách kéo vào khu vực phía trên',
    fileName: 'Tên tệp',
    description: 'Mô tả',
    descriptionPlaceholder: 'Mô tả ngắn về tệp (tùy chọn)',
    uploadFile: 'Tải tệp lên',
    upload: 'Tải lên',
    download: 'Tải xuống',
    rename: 'Đổi tên',
    delete: 'Xóa',
    confirmDelete: 'Bạn có chắc muốn xóa tệp này không?',
    uploadSuccess: 'Đã tải tệp lên',
    uploadError: 'Tải tệp lên thất bại',
    deleteSuccess: 'Đã xóa tệp',
    deleteError: 'Xóa tệp thất bại',
  },
  documents: {
    title: 'Tài liệu',
    description: 'Mẫu hợp đồng và tạo tài liệu PDF theo giao dịch',
    templates: 'Mẫu',
    list: 'Tài liệu',
    create: 'Tạo',
    filters: { status: 'Trạng thái' },
    status: { draft: 'Bản nháp', ready: 'Sẵn sàng' },
    columns: {
      title: 'Tên',
      template: 'Mẫu',
      date: 'Ngày tài liệu',
      size: 'Kích thước',
      created: 'Ngày tạo',
      status: 'Trạng thái',
    },
    actions: { generate: 'Tạo tài liệu', download: 'Tải xuống', rename: 'Đổi tên', delete: 'Xóa' },
    empty: {
      title: 'Chưa có tài liệu',
      description: 'Tạo tài liệu đầu tiên từ mẫu ở trên',
      filtered: 'Không có kết quả phù hợp với bộ lọc',
    },
    generate: {
      title: 'Tài liệu mới',
      template: 'Mẫu',
      deal: 'Giao dịch',
      selectDeal: 'Chọn giao dịch',
      client: 'Khách hàng',
      selectClient: 'Chọn khách hàng',
      amount: 'Số tiền',
      amountPlaceholder: 'Nhập số tiền',
      amountInvalid: 'Số tiền phải là số dương',
      noTemplates: 'Mẫu không khả dụng — hãy thử tải lại trang',
      date: 'Ngày hợp đồng',
      submit: 'Tạo',
      success: 'Đã tạo tài liệu',
      error: 'Không thể tạo tài liệu',
    },
    rename: {
      title: 'Đổi tên tài liệu',
      name: 'Tên',
      success: 'Đã đổi tên tài liệu',
      error: 'Không thể đổi tên tài liệu',
    },
    confirmDelete: 'Xóa tài liệu này? Tệp sẽ bị xóa vĩnh viễn.',
    deleteSuccess: 'Đã xóa tài liệu',
    deleteError: 'Không thể xóa tài liệu',
    downloadError: 'Không thể tải tệp',
    loadError: 'Không thể tải danh sách tài liệu',
    templatesError: 'Không thể tải mẫu',
    retry: 'Thử lại',
  },
  deals: {
    // DEV-210. Hạn của nhiệm vụ gần nhất trên thẻ kanban.
    nextTask: {
      today: 'hôm nay',
      tomorrow: 'ngày mai',
      inDays: 'sau {n} {unit}',
      overdue: 'quá hạn {n} {unit}',
      dayOne: 'ngày',
      dayFew: 'ngày',
      dayMany: 'ngày',
    },
    title: 'Giao dịch',
    createDeal: 'Tạo giao dịch',
    searchPlaceholder: 'Tìm theo tiêu đề hoặc bình luận…',
    funnelSummary: 'Phễu bán hàng · {count} đang hoạt động · {amount} đang xử lý',
    views: {
      aria: 'Chế độ xem: bảng hoặc danh sách',
      board: 'Bảng',
      list: 'Danh sách',
    },
    table: {
      deal: 'Giao dịch',
      client: 'Khách hàng',
      property: 'Bất động sản',
      stage: 'Giai đoạn',
      amount: 'Số tiền',
      manager: 'Quản lý',
      stageTasks: 'Việc của giai đoạn',
    },
    list: {
      groupByStage: 'Nhóm theo giai đoạn',
      stageReadyShort: 'Sẵn sàng',
      mandatoryShort: 'BB',
    },
    loading: 'Đang tải giao dịch...',
    emptyState: 'Không tìm thấy giao dịch',
    emptyStateDescription: 'Tạo giao dịch đầu tiên để bắt đầu',
    noDeals: 'Không có giao dịch',
    export: {
      csv: 'CSV (bảng)',
      xlsx: 'Excel (XLSX)',
    },
    card: {
      noProperty: 'Chưa chọn bất động sản',
      noPrice: 'Chưa có số tiền',
      noClient: 'Chưa có khách hàng',
      stageReady: 'Sẵn sàng chuyển bước',
      stageBlocked: 'Còn việc bắt buộc',
      unassigned: 'Chưa phân công',
      openInNewTab: 'Mở trong tab mới',
    },
    board: {
      ropOnly: 'Trưởng nhóm',
      configurePipeline: 'Cấu hình phễu',
      wipOver: 'Vượt giới hạn thẻ (WIP)',
      collapseColumn: 'Thu gọn cột',
      expandColumn: 'Mở rộng cột',
      noSum: 'Chưa xác định số tiền',
      fullscreen: 'Mở rộng toàn màn hình',
      exitFullscreen: 'Thu gọn',
      scrollToRight: 'Cuộn sang mép phải',
      scrollToLeft: 'Cuộn sang mép trái',
    },
    stats: {
      total: 'Tổng cộng',
      active: 'Hoạt động',
      won: 'Thắng',
      lost: 'Thua',
      allTime: 'tất cả thời gian',
      inWork: '{amount} đang xử lý',
      conversion: 'chuyển đổi {percent}%',
    },
    // DEV-42 / DEV-50: 15 giai đoạn của phễu bán hàng.
    stages: {
      STAGE_TYPE_INVALID: 'Không hợp lệ',
      STAGE_TYPE_UNSORTED: 'Chưa phân loại',
      STAGE_TYPE_NEW_LEAD: 'Khách hàng tiềm năng mới',
      STAGE_TYPE_NO_CONTACT: 'Không liên lạc được',
      STAGE_TYPE_CONTACTED: 'Đã liên lạc',
      STAGE_TYPE_QUALIFIED: 'Đã đủ điều kiện',
      STAGE_TYPE_OFFER_SENT: 'Đã gửi đề xuất',
      STAGE_TYPE_PRESENTATION_SCHEDULED: 'Đã lên lịch thuyết trình',
      STAGE_TYPE_PRESENTATION_DONE: 'Đã thuyết trình dự án',
      STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE: 'Đã có buổi gặp lại / thuyết trình bổ sung',
      STAGE_TYPE_BOOKED: 'Đã chọn căn',
      STAGE_TYPE_DEPOSIT_PAID: 'Đã đặt cọc',
      STAGE_TYPE_CONTRACT_SIGNED: 'Đã ký hợp đồng đặt chỗ / nộp DP',
      STAGE_TYPE_CONTRACT_HANDED_OVER: 'Đã chuyển hợp đồng cho chủ đầu tư',
      STAGE_TYPE_COMMISSION_PAID: 'Đã thanh toán hoa hồng',
      STAGE_TYPE_LOST: 'Đã đóng và không thực hiện',
    },
    // DEV-49: tham chiếu lý do đóng (key đến từ backend close_reasons).
    closeReason: {
      AGENT: 'Đại lý',
      RENTAL_NOT_PURCHASE: 'Cho thuê — không có ý định mua',
      BOUGHT_OTHER: 'Đã mua ở nơi khác',
      NO_REQUEST_SUBMITTED: 'Chưa gửi yêu cầu',
      NO_CONTACT_5_TOUCHES: 'Không liên lạc được sau 5 lần',
      STOPPED_RESPONDING: 'Ngừng phản hồi',
      LANGUAGE_BARRIER: 'Rào cản ngôn ngữ (không nói RU/EN)',
      NO_BUDGET: 'Không có ngân sách',
      NOT_CONSIDERING_VIETNAM: 'Không xem xét Việt Nam',
      INVALID_CONTACTS: 'Liên hệ không hợp lệ',
      NOT_TARGET: 'Không phải khách hàng mục tiêu',
      DEFERRED_DEMAND: 'Nhu cầu trì hoãn',
      PURCHASE_BEYOND_6_MONTHS: 'Mua sau hơn 6 tháng',
      CLIENT_ARCHIVED: 'Khách hàng đã lưu trữ',
    },
    statuses: {
      DEAL_STATUS_INVALID: 'Không hợp lệ',
      DEAL_STATUS_ACTIVE: 'Hoạt động',
      DEAL_STATUS_WON: 'Thắng',
      DEAL_STATUS_LOST: 'Thua',
      DEAL_STATUS_CANCELED: 'Đã hủy',
    },
    filters: {
      allStatuses: 'Tất cả trạng thái',
      allManagers: 'Tất cả quản lý',
      allAgents: 'Tất cả đại lý',
      allComplexes: 'Tất cả khu dân cư',
      complexes: 'Khu dân cư',
      complexSearch: 'Tên khu dân cư',
      taskStateHint:
        'Không có việc đang làm — ở giai đoạn hiện tại không có công việc chưa hoàn thành. Quá hạn và hôm nay — theo mọi công việc của giao dịch; «Hôm nay — tất cả» tính cả công việc đã hoàn thành',
      taskState: {
        all: 'Tất cả công việc',
        none: 'Không có việc đang làm',
        overdue: 'Công việc quá hạn',
        today_all: 'Hôm nay — tất cả',
        today: 'Hôm nay — đang thực hiện',
      },
      allClientSources: 'Tất cả kênh',
      allLeadSources: 'Tất cả nguồn khách hàng',
      leadSources: 'Nguồn khách hàng',
      clientPanel: 'Khách hàng',
      clientPanelHint:
        'Lọc theo khách hàng: thành phố, ngôn ngữ, thẻ, lý do lưu trữ, ngày có khách',
      leadCreated: 'Ngày có khách hàng',
      agentSegment: {
        all: 'Tất cả giao dịch',
        withAgent: 'Có đại lý',
        withoutAgent: 'Không có đại lý',
      },
      allStages: 'Tất cả giai đoạn',
      dateRange: 'Thời gian tạo',
      search: 'Tìm theo tiêu đề',
    },
    detail: {
      totalPrice: 'Tổng giá',
      commissionPlannedDate: 'Ngày dự kiến hoa hồng',
      finance: {
        title: 'Tài chính giao dịch',
        formula: 'cơ sở = giá chưa VAT × tỷ lệ dự án',
        moneyTitle: 'Tiền của giao dịch',
        rewardsTitle: 'Thù lao',
        rewardsSubtitle: 'phần của đại lý và đội ngũ tính trên cơ sở',
        resultTitle: 'Kết quả giao dịch',
        totalWithVat: 'Số tiền gồm VAT',
        totalWithoutVat: 'Số tiền chưa VAT',
        vatHint: 'VAT {rate} %',
        developerRate: 'Chủ đầu tư · tỷ lệ',
        developerRateField: 'Tỷ lệ chủ đầu tư, %',
        editRate: 'Đổi tỷ lệ chủ đầu tư',
        rewardBase: 'Cơ sở thù lao',
        teamGroup: 'Đội ngũ',
        managerReward: 'Quản lý',
        hosReward: 'Trưởng phòng kinh doanh',
        editHosRate: 'Đổi tỷ lệ trưởng phòng',
        agentReward: 'Thù lao đại lý',
        editAgentRate: 'Đổi tỷ lệ đại lý',
        hosRateField: 'Tỷ lệ trưởng phòng, %',
        agentRateField: 'Tỷ lệ đại lý, %',
        supportReward: 'Quản lý hỗ trợ',
        netRevenue: 'Doanh thu ròng',
        shareOfBase: '{percent} % của cơ sở',
        includeInRevenue: 'Tính vào doanh thu hoạt động',
        payments: 'Thanh toán và hoá đơn',
        unitCode: 'Mã căn hộ',
        hotBonus: 'Hot bonus',
        adminFee: 'Admin fee',
        rateRange: 'Tỷ lệ phải từ 0 đến 100',
        saved: 'Đã lưu tài chính giao dịch',
        rateConfirm: {
          developerTitle: 'Đổi tỷ lệ chủ đầu tư?',
          hosTitle: 'Đổi tỷ lệ trưởng phòng?',
          agentTitle: 'Đổi tỷ lệ đại lý?',
          description: 'Tỷ lệ quyết định cơ sở thù lao và doanh thu ròng của giao dịch.',
          impact: 'Hiện tại: cơ sở {base} · doanh thu ròng {net}',
        },
      },
      registry: {
        title: 'Thanh toán và hoá đơn',
        subtitle: 'hoá đơn của chủ đầu tư và hoa hồng đã nhận',
        hint: 'Dòng sổ giao dịch: khi nào chủ đầu tư xuất hoá đơn, khi nào chờ tiền và đã nhận được gì. Lưu toàn bộ — ô để trống sẽ xoá giá trị.',
        edit: 'Sửa thanh toán',
        plannedInvoiceDate: 'Hoá đơn, dự kiến',
        realInvoiceDate: 'Hoá đơn, thực tế',
        firstPaymentDate: 'Thanh toán đợt 1, ngày',
        firstPaymentAmount: 'Thanh toán đợt 1, số tiền',
        firstPayment: 'Thanh toán đợt 1',
        secondPaymentDate: 'Thanh toán đợt 2, ngày',
        secondPaymentAmount: 'Thanh toán đợt 2, số tiền',
        secondPayment: 'Thanh toán đợt 2',
        commissionReceiptDate: 'Hoa hồng đã nhận, ngày',
        commissionReceived: 'Hoa hồng đã nhận',
        downPaymentPlanDate: 'Đợt đầu, dự kiến',
        salesDeptCommission: 'Hoa hồng phòng kinh doanh',
        reportNote: 'Ghi chú báo cáo',
        amountError: 'Số tiền phải là số không âm',
        percentError: 'Tỷ lệ từ 0 đến 100',
      },
      depositPaidAt: 'Ngày đặt cọc',
      depositDateUpdated: 'Đã lưu ngày đặt cọc',
      client: 'Khách hàng',
      property: 'Khu dân cư',
      object: 'Đối tượng',
      closeReason: 'Lý do đóng',
      funnel: 'Phễu bán hàng',
      stageOf: 'giai đoạn {current}/{total}',
      nextStage: 'Tiếp theo: {stage}',
      changeProperty: 'Thay đổi',
      selectProperty: 'Chọn bất động sản',
      changePropertyTitle: 'Bất động sản',
      propertyUpdated: 'Đã cập nhật bất động sản của giao dịch',
      propertyUpdateError: 'Không thể cập nhật bất động sản của giao dịch',
      comments: 'Bình luận quản lý',
      summary: 'Tóm tắt',
      changeStage: 'Thay đổi giai đoạn',
      tasks: 'Nhiệm vụ',
      addTask: 'Thêm nhiệm vụ',
      editTask: 'Chỉnh sửa nhiệm vụ',
      noDescription: 'Không có mô tả',
      taskDescription: 'Mô tả',
      taskDescriptionPlaceholder: 'Mô tả nhiệm vụ',
      taskDueDate: 'Ngày đến hạn',
      taskDueTime: 'Giờ',
      taskAssignee: 'Người thực hiện',
      mandatoryTask: 'Bắt buộc',
      optionalTask: 'Không bắt buộc',
      taskDone: 'Hoàn thành',
      currentStageTasks: 'Việc của giai đoạn hiện tại',
      stageTasksNote: 'từ mẫu giai đoạn',
      manualTasks: 'Thêm thủ công',
      manualTasksNote: 'không chặn chuyển tiếp',
      manualTask: 'Thủ công',
      noDueDate: 'Không có hạn',
      manualAddedAt: 'Đã thêm {date}',
      upcomingNote: 'không chặn việc chuyển bước hiện tại',
      pastAllDone: 'đã đóng hết',
      pastOpenHint: 'Công việc còn lại từ các giai đoạn đã qua — hãy đóng nếu không còn cần',
      noStageTasks: 'Giai đoạn chưa có việc',
      funnelBlocked: 'chuyển bước bị chặn',
      tabOverview: 'Tổng quan',
      tabFinance: 'Tài chính',
      clientAndObject: 'Khách hàng và bất động sản',
      tabHistory: 'Lịch sử',
      tabDocuments: 'Tài liệu',
      tabChats: 'Trò chuyện',
      loadError: 'Không tải được giao dịch',
      createdAt: 'tạo {date}',
      editPrice: 'Sửa số tiền',
      rate: '1 USD ≈ {rate}',
      moreActions: 'Thao tác với giao dịch',
      noHistory: 'Chưa có thay đổi',
      stageMenu: {
        locked: 'hoàn thành {n} công việc bắt buộc',
      },
      deleteConfirm: {
        title: 'Xóa giao dịch #{id}?',
        description: 'Hành động không thể hoàn tác',
      },
      priority: {
        high: 'Cao',
        medium: 'Trung bình',
        low: 'Thấp',
      },
      block: {
        blockedTitle: 'Chuyển sang «{stage}» bị chặn',
        blockedHint:
          'Hoàn thành các việc bắt buộc của giai đoạn — việc thủ công không chặn chuyển tiếp',
        closeMandatory: 'Hoàn thành {n} công việc bắt buộc của giai đoạn',
        okTitle: 'Đã hoàn thành tất cả việc bắt buộc',
        okHint: 'Có thể chuyển giao dịch sang giai đoạn tiếp theo',
        mandatory: 'bắt buộc',
      },
      timer: {
        today: 'Hôm nay',
        leftOne: 'Còn 1 {unit}',
        left: 'Còn {n} {unit}',
        overdue: 'Trễ {n} {unit}',
        inTime: 'Sau {n} {unit}',
        createdDue: 'Tạo {created} · hạn {due}',
        day_one: 'ngày',
        day_few: 'ngày',
        day_many: 'ngày',
        hour_one: 'giờ',
        hour_few: 'giờ',
        hour_many: 'giờ',
        task_one: 'việc',
        task_few: 'việc',
        task_many: 'việc',
      },
      taskAssigneeDefault: 'Quản lý phụ trách giao dịch (mặc định)',
      taskAssigneeSupport: '{name} (quản lý hỗ trợ)',
      taskCalendarHint:
        'Nhiệm vụ có hạn chót sẽ tự động xuất hiện trong lịch của quản lý phụ trách giao dịch',
      reminderCustomHours: 'Trước N giờ',
      reminderHours: 'Số giờ trước hạn',
      actionLogs: 'Lịch sử thay đổi',
      files: 'Tệp',
      managersHistory: 'Lịch sử quản lý',
      managersHistoryCurrent: 'hiện tại',
      managersHistorySince: 'từ',
      confirmDeleteTask: 'Xóa nhiệm vụ?',
      dealDeleted: 'Giao dịch đã xóa',
      titleUpdated: 'Tiêu đề đã cập nhật',
      stageChanged: 'Giai đoạn đã thay đổi',
      priceUpdated: 'Giá đã cập nhật',
      commissionDateUpdated: 'Đã cập nhật ngày dự kiến hoa hồng',
      agent: {
        model: 'Mô hình',
        special: 'Đặc biệt',
        rewardPercent: 'Thù lao, %',
        involvement: 'Mức tham gia',
        involvementStatus: {
          lead_transfer_only: 'Chỉ chuyển khách',
          joint_route: 'Cùng phụ trách',
          inactive: 'Không hoạt động',
          dispute: 'Tranh chấp',
        },
        expectedRewardDate: 'Ngày dự kiến chi trả',
        rewardStatus: 'Trạng thái thù lao',
        rewardStatuses: {
          not_applicable: 'Không áp dụng',
          expected: 'Dự kiến',
          approved: 'Đã duyệt',
          paid: 'Đã trả',
          disputed: 'Tranh chấp',
          cancelled: 'Đã hủy',
        },
        invalidDate: 'Ngày không hợp lệ',
        rewardDateUpdated: 'Đã cập nhật ngày chi trả',
        rewardGroup: 'Thù lao đại lý',
        details: 'Chi tiết',
        commissionBase: 'Cơ sở hoa hồng',
        expectedReward: 'Thù lao dự kiến',
        specialTerms: 'Điều kiện đặc biệt',
        meetings: 'Số buổi gặp với đại lý',
        depositPaidAt: 'Đã đặt cọc',
      },
      updateError: 'Cập nhật thất bại',
      stageChangeError: 'Không thể thay đổi giai đoạn',
      priceUpdateError: 'Không thể cập nhật giá',
      addFirstTask: 'Thêm công việc đầu tiên',
      taskAdded: 'Đã thêm công việc',
      taskAddError: 'Không thể thêm công việc',
      taskDeleted: 'Đã xóa công việc',
      taskDeleteError: 'Không thể xóa công việc',
      taskMarkedComplete: 'Công việc đã được đánh dấu hoàn thành',
      taskReopened: 'Công việc đã được mở lại',
      taskUpdated: 'Đã cập nhật nhiệm vụ',
      tasksCard: {
        loadError: 'Không tải được công việc',
        add: 'Công việc',
        stage: 'giai đoạn «{stage}»',
        pipeline: 'phễu «{pipeline}»',
        upcoming: 'Công việc các giai đoạn tiếp theo ({n})',
        past: 'Công việc ở giai đoạn đã qua ({n})',
        pastOpen: '{n} chưa đóng',
        stageGone: 'Giai đoạn đã bị xoá',
        menu: 'Thao tác với công việc',
      },
      summaryCard: {
        subtitle: 'đối tượng và các mốc chính',
        dates: 'Tạo {created} · cập nhật {updated}',
      },
    },
    form: {
      back: '← Trở lại',
      newDeal: 'Giao dịch mới',
      editDeal: 'Chỉnh sửa giao dịch',
      clientHint: 'Bán cho ai — chọn khách hàng hiện có.',
      objectOptionalHint: 'Có thể không chọn bất động sản — ví dụ cho giai đoạn «Chưa phân loại».',
      wizard: {
        subtitle: 'Tạo giao dịch theo từng bước',
        stepsCap: 'CÁC BƯỚC',
        stepOf: 'Bước {current}/{total}',
        step1: 'Khách hàng',
        step1desc: 'Bán cho ai',
        step2: 'Bất động sản',
        step2desc: 'Dự án & căn · tùy chọn',
        step3: 'Số tiền',
        step3desc: 'Giá & điều kiện',
        step4: 'Kiểm tra',
        step4desc: 'Xác nhận',
        skip: 'Bỏ qua',
        back: 'Quay lại',
        next: 'Tiếp theo',
        create: 'Tạo giao dịch',
        reviewHint:
          'Kiểm tra dữ liệu và nhấn «Tạo giao dịch». Giao dịch sẽ xuất hiện trong phễu ở giai đoạn đã chọn.',
      },
      loadingData: 'Đang tải dữ liệu giao dịch...',
      mainInfo: 'Thông tin chính',
      dealTitle: 'Tiêu đề giao dịch',
      dealTitlePlaceholder: 'Ví dụ: Bán căn hộ ở trung tâm',
      relations: 'Liên kết',
      client: 'Khách hàng',
      selectClient: 'Chọn khách hàng',
      clientId: 'ID khách hàng',
      clientIdPlaceholder: 'ID khách hàng',
      responsibleManager: 'Người quản lý chịu trách nhiệm',
      managerIdPlaceholder: 'ID quản lý',
      // DEV-699. Ответственный по сделке наследуется от ответственного менеджера клиента.
      managerAutoAssigned: 'Được chỉ định theo người quản lý phụ trách khách hàng',
      property: 'Bất động sản',
      selectProperty: 'Khu dân cư',
      selectPropertyPlaceholder: 'Chọn khu dân cư',
      selectObject: 'Đối tượng',
      selectObjectPlaceholder: 'Chọn đối tượng',
      propertyId: 'ID bất động sản',
      propertyIdPlaceholder: 'ID bất động sản',
      objectId: 'ID đối tượng',
      objectIdPlaceholder: 'ID đối tượng',
      stageAndFinances: 'Giai đoạn & Tài chính',
      initialStage: 'Giai đoạn ban đầu',
      selectStage: 'Chọn giai đoạn',
      finances: 'Tài chính',
      currency: 'Tiền tệ',
      selectCurrency: 'Chọn tiền tệ',
      willBeSavedVnd: 'Sẽ được lưu là {amount}',
      totalPrice: 'Tổng giá',
      priceInCents: 'Giá theo cent',
      dealStatus: 'Trạng thái giao dịch',
      status: 'Trạng thái',
      noChange: 'Không thay đổi',
      comment: 'Bình luận',
      additionalInfo: 'Thông tin bổ sung',
      commentPlaceholder: 'Thêm bình luận vào giao dịch...',
      titleRequired: 'Tiêu đề là bắt buộc',
      titleAutoGenerated: 'Nếu trống, sẽ được tạo từ tên khách hàng và tên bất động sản',
      clientIdRequired: 'Khách hàng là bắt buộc',
      saveError: 'Lỗi khi lưu giao dịch',
    },
    actions: {
      // DEV-49: согласовано с этапом "Đã đóng và thất bại" (LOST).
      cancel: 'Bỏ lỡ',
    },
    // DEV-699. Команда сделки: ответственный + сопровождающие менеджеры.
    team: {
      title: 'Đội ngũ giao dịch',
      responsible: 'Người quản lý chịu trách nhiệm',
      supportManagers: 'Quản lý hỗ trợ',
      noSupportManagers: 'Chưa có quản lý hỗ trợ',
      addSupport: 'Thêm quản lý hỗ trợ',
      noCandidates: 'Không có quản lý hỗ trợ khả dụng',
      removeConfirm: 'Gỡ quản lý hỗ trợ {name} khỏi giao dịch này?',
      addSuccess: 'Đã thêm quản lý hỗ trợ',
      addError: 'Không thể thêm quản lý hỗ trợ',
      addErrorIsResponsible:
        'Người dùng này đã là quản lý phụ trách giao dịch. Hãy đổi quản lý phụ trách của khách hàng trước.',
      removeSuccess: 'Đã gỡ quản lý hỗ trợ',
      removeError: 'Không thể gỡ quản lý hỗ trợ',
      candidatesError: 'Không thể tải danh sách quản lý hỗ trợ',
      // DEV-715. Thay đổi người quản lý chịu trách nhiệm (thông qua khách hàng).
      selectManager: 'Chọn quản lý',
      responsibleChangeConfirmTitle: 'Thay đổi người quản lý chịu trách nhiệm?',
      responsibleChangeConfirmDescription:
        'Người quản lý chịu trách nhiệm sẽ thay đổi: {from} → {to}.',
      responsibleChangeConfirmWarning:
        'Người quản lý chịu trách nhiệm được thay đổi ở khách hàng — tất cả giao dịch đang hoạt động của khách hàng này sẽ chuyển sang quản lý mới.',
      responsibleChangeSuccess: 'Đã cập nhật người quản lý chịu trách nhiệm',
      responsibleChangeError: 'Không thể thay đổi người quản lý chịu trách nhiệm',
      snapshotHint: 'Ảnh chụp giao dịch — cố định khi tạo, chỉnh sửa trong thẻ khách hàng',
      responsibleChangePending:
        'Thay đổi đã được ghi nhận và sẽ áp dụng trong vòng một phút. Hãy tải lại trang sau.',
    },
    cancelModal: {
      title: 'Hủy giao dịch',
      subtitle: 'Giao dịch «{title}» sẽ được chuyển sang giai đoạn “Đã đóng và thất bại”.',
      reasonLabel: 'Lý do đóng',
      reasonPlaceholder: 'Chọn lý do...',
      reasonRequired: 'Bắt buộc chọn lý do đóng',
      commentLabel: 'Bình luận của quản lý',
      commentPlaceholder: 'Thông tin bổ sung (tùy chọn)',
      confirmTitle: 'Xác nhận hành động',
      confirmCancel: 'Bạn có chắc chắn muốn hủy giao dịch này không?',
      confirmButton: 'Có, hủy',
      cancelSuccess: 'Giao dịch đã được hủy thành công',
      cancelError: 'Lỗi khi hủy giao dịch',
    },
    kanban: {
      dealMoved: 'Giao dịch đã chuyển sang "{stage}"',
      moveError: 'Lỗi khi di chuyển giao dịch',
      cancelForbidden: 'Bạn chỉ có thể hủy giao dịch của riêng mình',
    },
    currencies: {
      CURRENCY_VND: 'VND (Đồng Việt Nam)',
      CURRENCY_USD: 'USD (Đô la Mỹ)',
      CURRENCY_RUB: 'RUB (Rúp Nga)',
    },
    // DEV-195. Bình luận của quản lý (1:N) trong thẻ giao dịch.
    comments: {
      title: 'Bình luận của quản lý',
      empty: 'Chưa có bình luận',
      placeholder: 'Viết bình luận…',
      add: 'Thêm',
      addSuccess: 'Đã thêm bình luận',
      addError: 'Không thể thêm bình luận',
      updateSuccess: 'Đã cập nhật bình luận',
      updateError: 'Không thể cập nhật bình luận',
      deleteSuccess: 'Đã xóa bình luận',
      deleteError: 'Không thể xóa bình luận',
      confirmDelete: 'Xóa bình luận này?',
      edited: 'đã chỉnh sửa',
      unknownAuthor: 'Tác giả không xác định',
      subtitle: 'mới nhất ở trên · bình luận đại lý được tô sáng',
      agentBadge: 'Đại lý',
      agentAuthor: 'Đại lý',
    },
  },
  notifications: {
    title: 'Thông báo',
    empty: 'Không có thông báo',
    emptyDesc: 'Thông báo về tin nhắn mới và sự kiện sẽ xuất hiện ở đây',
    markAllRead: 'Đánh dấu tất cả đã đọc',
    viewAll: 'Tất cả thông báo',
    loadMore: 'Tải thêm',
    allMarkedRead: 'Đã đánh dấu đã đọc: {n}',
    time: {
      justNow: 'vừa xong',
      minutesAgo: '{n} phút trước',
      hoursAgo: '{n} giờ trước',
      daysAgo: '{n} ngày trước',
    },
    webPush: {
      enableTitle: 'Bật thông báo đẩy',
      enableDesc: 'Nhận thông báo về tin nhắn mới ngay trên trình duyệt',
      enable: 'Bật',
      enabled: 'Đã bật thông báo đẩy',
      denied: 'Quyền thông báo bị từ chối. Kiểm tra cài đặt trình duyệt',
    },
    channels: {
      webpush: 'Web Push',
      telegram: 'Telegram',
    },
  },
  settings: {
    title: 'Cài đặt cá nhân',
    display: {
      title: 'Hiển thị',
      language: 'Ngôn ngữ giao diện',
      languageDesc: 'Chọn ngôn ngữ cho giao diện',
      theme: 'Chủ đề',
      themeDesc: 'Chọn bảng màu cho giao diện',
      itemsPerPage: 'Số mục mỗi trang',
      itemsPerPageDesc: 'Số lượng mục hiển thị trong danh sách',
      showHints: 'Hiển thị gợi ý',
      showHintsDesc: 'Hiển thị gợi ý và hướng dẫn trong giao diện',
    },
    languages: {
      ru: 'Русский',
      en: 'English',
      vn: 'Tiếng Việt',
    },
    themes: {
      light: 'Sáng',
      dark: 'Tối',
      auto: 'Tự động (Hệ thống)',
    },
    notifications: {
      title: 'Thông báo',
      groups: {
        deals: 'Sự kiện giao dịch',
        tasks: 'Công việc',
        comm: 'Liên lạc',
      },
      types: {
        assigned: 'Được giao phụ trách',
        stage: 'Giai đoạn giao dịch thay đổi',
        wonlost: 'Giao dịch thắng/thua',
        newtask: 'Công việc mới của giai đoạn',
        overdue: 'Công việc quá hạn',
        digest: 'Tóm tắt công việc hằng ngày',
        reminder: 'Nhắc lịch',
        comment: 'Bình luận mới',
        missed: 'Cuộc gọi nhỡ',
        unread: 'Tin nhắn chưa đọc',
      },
      channels: {
        title: 'Kênh gửi',
        push: 'Push (ứng dụng di động)',
        webpush: 'Push trình duyệt',
        email: 'Email',
        telegram: 'Telegram',
        whatsapp: 'WhatsApp',
      },
      telegram: {
        title: 'Telegram Bot',
        desc: 'Nhận thông báo về tin nhắn chưa đọc qua Telegram bot',
        linked: 'Đã liên kết',
        notLinked: 'Chưa liên kết',
        username: 'Tài khoản Telegram',
        link: 'Liên kết Telegram',
        unlink: 'Hủy liên kết',
        linkInstructions: 'Nhấn vào liên kết bên dưới và gửi /start cho bot',
        openBot: 'Mở bot',
        codeExpires: 'Liên kết có hiệu lực trong 10 phút',
        linkCodeError: 'Không lấy được liên kết tới bot. Vui lòng thử lại sau.',
        confirmUnlink: 'Hủy liên kết Telegram bot? Bạn sẽ không nhận thông báo nữa.',
        unlinkSuccess: 'Đã hủy liên kết Telegram bot',
        linkSuccess: 'Đã liên kết Telegram bot! Kiểm tra bot — nó sẽ xác nhận liên kết.',
        checking: 'Đang kiểm tra...',
        waitingLink: 'Đang chờ kết nối bot...',
      },
      // DEV-2320: bot thứ hai chỉ cho thông báo khách hàng tiềm năng mới.
      telegramLeads: {
        title: 'Telegram bot cho khách hàng tiềm năng',
        desc: 'Nhận thông báo về khách hàng tiềm năng mới qua một Telegram bot riêng',
        confirmUnlink:
          'Hủy liên kết bot khách hàng tiềm năng? Thông báo về khách hàng tiềm năng mới sẽ được gửi vào bot chung.',
        assignedHint:
          'Thông báo giao khách hàng tiềm năng được gửi vào bot khách hàng tiềm năng nếu đã liên kết',
      },
      whatsapp: {
        title: 'Thông báo WhatsApp',
        desc: 'Nhận thông báo qua WhatsApp',
        linked: 'Đã kết nối',
        notLinked: 'Chưa kết nối',
        phonePlaceholder: 'Số WhatsApp',
        save: 'Lưu số',
        unlink: 'Hủy liên kết',
        confirmUnlink: 'Hủy liên kết WhatsApp? Bạn sẽ không nhận thông báo nữa.',
      },
      webPush: {
        title: 'Thông báo đẩy trình duyệt',
        desc: 'Nhận thông báo trực tiếp trong trình duyệt ngay cả khi CRM không ở tab đang hoạt động',
        notSupported: 'Trình duyệt của bạn không hỗ trợ thông báo đẩy',
        permissionDenied:
          'Quyền thông báo bị từ chối. Cho phép thông báo trong cài đặt trình duyệt và tải lại trang',
        enable: 'Bật thông báo đẩy',
        disable: 'Tắt thông báo đẩy',
        enabled: 'Đã bật',
        disabled: 'Đã tắt',
      },
    },
    actions: {
      reset: 'Đặt lại cài đặt',
      save: 'Lưu thay đổi',
    },
    confirmReset: 'Bạn có chắc chắn muốn đặt lại tất cả cài đặt về giá trị mặc định?',
    saved: 'Đã lưu cài đặt!',
  },
  auth: {
    // DEV-1177. Hiển thị khi guard vai trò loại tài khoản bên ngoài (đối tác) khỏi CRM.
    roleNotAllowed:
      'Tài khoản của bạn không có quyền truy cập CRM. Tài liệu dành cho đối tác ở docs.vinprop.vn.',
    // DEV-1775. Lý do từ chối đăng nhập hiển thị trên biểu mẫu, không phải toast.
    loginErrors: {
      deactivated: 'Tài khoản đã bị vô hiệu hóa. Vui lòng liên hệ quản trị viên.',
      notActivated: 'Tài khoản chưa được kích hoạt. Hãy mở email mời và hoàn tất đăng ký.',
      invalidCredentials: 'Tên đăng nhập hoặc mật khẩu không đúng.',
      generic: 'Không thể đăng nhập. Vui lòng thử lại.',
    },
    // DEV-2119. Đăng nhập bằng Google Workspace: nút và lý do từ chối.
    google: {
      button: 'Đăng nhập bằng Google',
      or: 'hoặc bằng mật khẩu',
      finishing: 'Đang hoàn tất đăng nhập…',
      errors: {
        unknown_user: {
          title: 'Không có tài khoản',
          text: 'Google đã xác nhận tài khoản, nhưng hệ thống không có người dùng với địa chỉ này. Hãy liên hệ quản trị viên — tài khoản được tạo trong CRM.',
        },
        foreign_domain: {
          title: 'Địa chỉ ngoài miền',
          text: 'Chỉ có thể đăng nhập bằng địa chỉ công việc. Tài khoản Google cá nhân không được phép.',
        },
        email_not_verified: {
          title: 'Địa chỉ chưa được xác minh',
          text: 'Google chưa xác minh địa chỉ của tài khoản này. Hãy xác minh trong cài đặt Google rồi thử lại.',
        },
        inactive_user: {
          title: 'Tài khoản đã bị vô hiệu hóa',
          text: 'Không thể đăng nhập bằng tài khoản này. Hãy liên hệ quản trị viên.',
        },
        identity_conflict: {
          title: 'Tài khoản đã được liên kết',
          text: 'Tài khoản Google này đã liên kết với người dùng khác. Hãy liên hệ quản trị viên.',
        },
        canceled: {
          title: 'Đăng nhập chưa hoàn tất',
          text: 'Cửa sổ chọn tài khoản Google đã đóng quá sớm. Hãy thử lại hoặc đăng nhập bằng mật khẩu.',
        },
        code_used: {
          title: 'Liên kết đã được sử dụng',
          text: 'Liên kết quay lại chỉ dùng được một lần và sống một phút. Hãy đăng nhập lại.',
        },
        failed: {
          title: 'Không thể đăng nhập',
          text: 'Có lỗi ở phía đăng nhập bằng Google. Hãy thử lại hoặc đăng nhập bằng mật khẩu.',
        },
      },
    },
    login: 'Đăng nhập',
    logout: 'Đăng xuất',
    roles: {
      admin: 'Quản trị viên',
      hos: 'Trưởng phòng kinh doanh',
      manager: 'Người quản lý',
      // DEV-699. Сопровождающий менеджер сделок.
      support_manager: 'Quản lý hỗ trợ',
      agent: 'Đại lý',
      marketer: 'Nhân viên marketing',
      // DEV-1976. Кампании, ссылки и лендинги с их SEO — и ничего сверх того.
      marketing_manager: 'Quản lý marketing',
      user: 'Người dùng',
      ADMIN: 'Quản trị viên',
      MANAGER: 'Người quản lý',
      AGENT: 'Đại lý',
      USER: 'Người dùng',
    },
    email: 'Email',
    password: 'Mật khẩu',
    forgotPassword: 'Quên mật khẩu?',
    rememberMe: 'Ghi nhớ đăng nhập',
    signIn: 'Đăng nhập',
    forgot: {
      title: 'Khôi phục mật khẩu',
      hint: 'Nhập e-mail của bạn — chúng tôi sẽ gửi liên kết đặt lại mật khẩu.',
      submit: 'Gửi',
      sent: 'Nếu e-mail này đã đăng ký, chúng tôi đã gửi liên kết đặt lại mật khẩu.',
      backToLogin: 'Quay lại đăng nhập',
      invalidEmail: 'Nhập e-mail hợp lệ',
    },
    reset: {
      title: 'Mật khẩu mới',
      newPassword: 'Mật khẩu mới',
      confirmPassword: 'Nhập lại mật khẩu',
      submit: 'Lưu',
      done: 'Đã đổi mật khẩu. Bây giờ hãy đăng nhập bằng mật khẩu mới.',
      tooShort: 'Mật khẩu phải có ít nhất 8 ký tự',
      mismatch: 'Mật khẩu không khớp',
      invalidToken: 'Liên kết không hợp lệ hoặc đã hết hạn. Hãy yêu cầu đặt lại mật khẩu lần nữa.',
    },
    // DEV-1308. Экран из письма-приглашения.
    accept: {
      title: 'Lời mời vào VINPROP',
      hint: 'Hãy đặt mật khẩu — tài khoản sẽ được tạo cho',
      firstName: 'Tên',
      lastName: 'Họ',
      password: 'Mật khẩu',
      confirmPassword: 'Nhập lại mật khẩu',
      submit: 'Tạo tài khoản',
      required: 'Vui lòng điền vào ô này',
      invalidToken: 'Lời mời không hợp lệ hoặc đã hết hạn. Hãy yêu cầu gửi lại lời mời.',
      failed: 'Không thể chấp nhận lời mời. Hãy thử lại hoặc yêu cầu lời mời mới.',
    },
  },
  languages: {
    ru: 'Русский',
    en: 'English',
    vn: 'Tiếng Việt',
  },
  countries: {
    by: 'Belarus',
    cn: 'Trung Quốc',
    fr: 'Pháp',
    de: 'Đức',
    in: 'Ấn Độ',
    id: 'Indonesia',
    jp: 'Nhật Bản',
    kz: 'Kazakhstan',
    my: 'Malaysia',
    ph: 'Philippines',
    ru: 'Nga',
    sa: 'Ả Rập Xê Út',
    sg: 'Singapore',
    kr: 'Hàn Quốc',
    th: 'Thái Lan',
    tr: 'Thổ Nhĩ Kỳ',
    ua: 'Ukraina',
    ae: 'Các Tiểu vương quốc Ả Rập Thống nhất',
    gb: 'Vương quốc Anh',
    us: 'Hoa Kỳ',
    vn: 'Việt Nam',
  },
  dashboard: {
    title: 'Bảng điều khiển',
    welcome: 'Chào mừng đến với VINPROP CRM',
    quickActions: 'Hành động nhanh',
    stats: {
      totalClients: 'Tổng số khách hàng',
      activeDeals: 'Giao dịch hoạt động',
      properties: 'Bất động sản',
      conversion: 'Chuyển đổi',
      newClients: 'Khách hàng mới',
      newDeals: 'Giao dịch mới',
      newProperties: 'Bất động sản mới',
      growth: '+{value}% trong {period}',
      newThisMonth: '{count} mới trong tháng này',
      stable: 'Ổn định',
      growing: 'Tăng',
      declining: 'Giảm',
    },
    periods: {
      day: 'ngày',
      week: 'tuần',
      month: 'tháng',
      year: 'năm',
    },
    actions: {
      manageClients: 'Quản lý khách hàng',
      viewDeals: 'Xem giao dịch',
      browseProperties: 'Duyệt bất động sản',
    },
    hero: {
      greeting: 'Chào mừng trở lại, {name}',
      summary: 'Tổng quan CRM của bạn',
    },
    range: {
      today: 'Hôm nay',
      week: 'Tuần',
      month: 'Tháng',
      all: 'Tất cả',
    },
    dealsDynamics: {
      title: 'Động lực giao dịch',
      subtitle: 'Giao dịch được tạo theo tháng',
      legend: 'Giao dịch',
      period: '6 tháng',
      empty: 'Không có dữ liệu',
      monthsShort: '{m} th',
    },
    comingSoon: {
      title: 'Sắp ra mắt',
      analytics: 'Sẽ có khi kết nối phân tích',
    },
    tasks: {
      title: 'Công việc hôm nay',
      empty: 'Không có công việc nào hôm nay',
      allDay: 'Cả ngày',
      add: 'Thêm công việc',
      more: 'Xem thêm {n} công việc',
      collapse: 'Thu gọn',
    },
    recentClients: {
      title: 'Khách hàng gần đây',
      viewAll: 'Xem tất cả',
      colClient: 'Khách hàng',
      colSource: 'Nguồn khách',
      colManager: 'Quản lý',
      colCity: 'Thành phố',
      colCreated: 'Đã thêm',
      empty: 'Chưa có khách hàng',
    },
    leadSources: {
      title: 'Nguồn khách hàng',
      unit: 'lead',
      empty: 'Chưa có dữ liệu nguồn',
    },
  },
  calendar: {
    title: 'Lịch',
    createEvent: 'Tạo sự kiện',
    editEvent: 'Chỉnh sửa sự kiện',
    deleteEvent: 'Xóa sự kiện',
    today: 'Hôm nay',
    more: 'thêm',
    moreTasks: 'công việc',
    allDay: 'Cả ngày',
    noEvents: 'Không có sự kiện',
    views: {
      month: 'Tháng',
      week: 'Tuần',
      day: 'Ngày',
      agenda: 'Lịch trình',
    },
    agenda: {
      empty: 'Không có sự kiện trong tháng này',
    },
    weekdays: {
      mon: 'T2',
      tue: 'T3',
      wed: 'T4',
      thu: 'T5',
      fri: 'T6',
      sat: 'T7',
      sun: 'CN',
    },
    form: {
      title: 'Tiêu đề',
      titlePlaceholder: 'Nhập tiêu đề sự kiện',
      description: 'Mô tả',
      descriptionPlaceholder: 'Nhập mô tả sự kiện',
      startDate: 'Ngày bắt đầu',
      startTime: 'Thời gian bắt đầu',
      endDate: 'Ngày kết thúc',
      endTime: 'Thời gian kết thúc',
      allDay: 'Cả ngày',
      entityType: 'Loại liên kết',
      reminder: 'Nhắc nhở',
      manager: 'Quản lý',
    },
    entityTypes: {
      none: 'Không liên kết',
      client: 'Khách hàng',
      deal: 'Giao dịch',
      clientTask: 'Công việc khách hàng',
      dealTask: 'Công việc giao dịch',
      trackerMeeting: 'Cuộc họp tracker',
    },
    reminders: {
      none: 'Không nhắc nhở',
      '5min': 'Trước 5 phút',
      '15min': 'Trước 15 phút',
      '30min': 'Trước 30 phút',
      '1hour': 'Trước 1 giờ',
      '1day': 'Trước 1 ngày',
    },
    addToCalendar: 'Thêm vào lịch',
    eventCreated: 'Đã tạo sự kiện',
    eventUpdated: 'Đã cập nhật sự kiện',
    eventDeleted: 'Đã xóa sự kiện',
    legend: {
      title: 'Loại sự kiện',
      client: 'Khách hàng',
      deal: 'Giao dịch',
      task: 'Công việc',
    },
    filters: {
      categories: 'Danh mục',
      client: 'Khách hàng',
      deal: 'Giao dịch',
      task: 'Công việc giao dịch',
      meeting: 'Cuộc họp',
      none: 'Không liên kết',
      managers: 'Quản lý',
      noManagers: 'Không tìm thấy quản lý',
      taskTypes: 'Loại nhiệm vụ',
      noTaskTypes: 'Chưa có loại nhiệm vụ',
      taskTypesNote: 'Chỉ hiển thị nhiệm vụ thuộc các loại đã chọn — mục không có loại bị ẩn.',
    },
    prevMonth: 'Tháng trước',
    nextMonth: 'Tháng sau',
    openInTracker: 'Mở trong tracker',
    openEntity: {
      deal: 'Mở giao dịch',
      client: 'Mở khách hàng',
    },
  },
  telephony: {
    noCalls: 'Không có cuộc gọi',
    callHistory: 'Lịch sử cuộc gọi',
    playRecording: 'Nghe ghi âm',
    transcriptionAndAi: 'Phiên âm & Phân tích AI',
    call: {
      endCall: 'Kết thúc cuộc gọi',
      calling: 'Đang gọi...',
      callTo: 'Gọi {phone}',
      call: 'Gọi',
      endCallLabel: 'Kết thúc',
      callFailed: 'Gọi thất bại',
      initiateFailed: 'Không thể thực hiện cuộc gọi',
    },
    activeCall: {
      ringing: 'Đang đổ chuông',
      answered: 'Đang nói chuyện',
      ended: 'Đã kết thúc',
      call: 'Cuộc gọi',
      callingEllipsis: 'Đang đổ chuông...',
      microphone: 'Micro',
      endCall: 'Kết thúc',
      generalCall: 'Cuộc gọi chung',
    },
    sip: {
      connected: 'SIP: đã kết nối',
      connecting: 'SIP: đang kết nối...',
      error: 'SIP: lỗi — {error}',
      disconnected: 'SIP: đã ngắt kết nối',
    },
    disposition: {
      answered: 'Đã trả lời',
      busy: 'Bận',
      cancel: 'Đã hủy',
      noAnswer: 'Không trả lời',
      failed: 'Thất bại',
      ringing: 'Đang đổ chuông',
    },
    recording: {
      loading: 'Đang tải ghi âm...',
      retry: 'Thử lại',
      pause: 'Tạm dừng',
      play: 'Phát',
      download: 'Tải xuống',
      unavailable: 'Ghi âm không có sẵn',
      loadError: 'Không thể tải ghi âm',
      playError: 'Lỗi phát lại',
    },
    transcription: {
      unavailable: 'Phiên âm không có sẵn',
      inProgress: 'Đang nhận dạng giọng nói...',
      error: 'Lỗi nhận dạng',
      aiAnalysis: 'Phân tích AI',
      nextSteps: 'Bước tiếp theo',
      title: 'Phiên âm',
      channel: {
        manager: 'Quản lý',
        client: 'Khách hàng',
        other: 'Kênh {n}',
      },
      qualification: {
        hot: '🔥 Nóng',
        warm: '🌤 Ấm',
        cold: '❄️ Lạnh',
      },
    },
  },
  messenger: {
    noDevice: {
      title: 'WhatsApp chưa kết nối',
      description: 'Kết nối tài khoản WhatsApp để xem cuộc trò chuyện với khách hàng',
      connectButton: 'Kết nối WhatsApp',
    },
    login: {
      title: 'Kết nối WhatsApp',
      scanHint: 'Mở WhatsApp → Thiết bị đã liên kết → Liên kết thiết bị',
      expiresIn: 'Hết hạn sau {duration} giây.',
      refreshQr: 'Làm mới QR',
      clickToGenerate: 'Nhấn "Làm mới QR" để tạo mã',
    },
    device: {
      connected: 'WhatsApp đã kết nối',
      disconnect: 'Ngắt kết nối',
      disconnectTitle: 'Ngắt kết nối WhatsApp',
      disconnectConfirm:
        'Bạn có chắc chắn muốn ngắt kết nối WhatsApp? Bạn sẽ cần quét lại mã QR để kết nối lại.',
    },
    selectChat: 'Chọn cuộc trò chuyện',
    searchPlaceholder: 'Tìm kiếm cuộc trò chuyện...',
    send: 'Gửi',
    typeMessage: 'Nhập tin nhắn...',
    attachFile: 'Đính kèm tệp',
    call: 'Gọi qua WhatsApp',
    // DEV-998: xem chat của quản lý khác ở chế độ chỉ đọc (ADMIN/CEO/HOS)
    readonly: {
      banner: '👁 Đang xem chat — chỉ đọc',
      bannerNamed: '👁 Đang xem chat của {name} — chỉ đọc',
      // DEV-1835: dòng tin gộp chỉ gửi vào chat Hỗ trợ, mà khách hàng chưa có chat này
      mergedNoSupport: '👁 Dòng tin gộp — chỉ đọc: khách hàng chưa có chat với Hỗ trợ',
      footer: '🔒 Chế độ xem — không thể gửi tin nhắn và gọi điện',
    },
    // DEV-2297: chat Hỗ trợ mở ra mà không đánh dấu đã đọc; chỉ trả lời được sau khi bấm nút
    supportRead: {
      hint: 'Tin nhắn chưa được đọc. Để trả lời, hãy bấm “Đọc”',
      button: 'Đọc',
    },
    crossView: {
      // DEV-1833: danh sách giờ có thêm «Hỗ trợ» bên cạnh các quản lý.
      selectorLabel: 'Trò chuyện',
      selfOption: 'Bạn',
      supportOption: 'Hỗ trợ',
      // DEV-2140: chat của quản lý khác, không phải người liên hệ cùng tên.
      managerOption: 'Chat cá nhân · {name}',
      // DEV-2227: lịch sử chat cá nhân của người khác hiện khi chủ chat mở nó
      historyNotLoaded:
        'Lịch sử chat sẽ hiện khi quản lý mở chat này trong CRM. Tin nhắn mới hiển thị ngay',
    },
    // DEV-1833: nhãn «Gửi với tư cách» trong khung soạn tin của chat hỗ trợ
    support: {
      sendAs: 'Gửi với tư cách: {name}',
      managerOptionSoon: 'Tính năng gửi thay quản lý sẽ có sau',
    },
    // DEV-1835: dòng tin gộp của chat hỗ trợ và TG cá nhân của các quản lý
    mergedFeed: {
      toggle: 'Gộp các cuộc trò chuyện',
      label: 'Gộp: {names}',
      toSupport: '→ tới Hỗ trợ',
      toManager: '→ {name}',
      fromManager: '{name} · quản lý · TG cá nhân',
      // chat riêng của admin trong dòng tin gộp — «Bạn», như trong nhãn thành phần
      toSelf: '→ tới bạn',
      fromSelf: 'Bạn · TG cá nhân',
      // phụ đề tiêu đề chat (bản mẫu MSG-15b)
      subtitle: 'Telegram · dòng tin gộp: {names}',
      // DEV-2227: nguồn nằm hoàn toàn phía trên phần đã tải của dòng tin
      hiddenAbove: 'Còn tin nhắn phía trên: {names}',
    },
    noContact: {
      title: 'Không có liên hệ WhatsApp',
      description: 'Thêm số WhatsApp vào danh bạ khách hàng để xem cuộc trò chuyện',
    },
    noChat: 'Chưa có cuộc trò chuyện với khách hàng',
    noChats: 'Không có cuộc trò chuyện',
    noMessages: 'Không có tin nhắn',
    newMessages: 'Tin nhắn mới',
    document: 'Tài liệu',
    callEvent: {
      // DEV-2443: подсказка на пузыре звонка в ленте.
      openInPanel: 'Mở trong lịch sử cuộc gọi',
      incoming: 'Cuộc gọi đến',
      outgoing: 'Cuộc gọi đi',
      incomingEnded: 'Cuộc gọi đến',
      outgoingEnded: 'Cuộc gọi đi',
      incomingRejected: 'Đã từ chối cuộc gọi đến',
      outgoingRejected: 'Người nhận đã từ chối',
      missed: 'Cuộc gọi nhỡ',
      noAnswer: 'Không trả lời',
      outgoingMissed: 'Không trả lời',
      duration: 'Thời lượng',
      youMissed: 'Bạn không trả lời',
      declined: 'Đã từ chối',
    },
    addCaption: 'Thêm chú thích...',
    loadMore: 'Tải thêm',
    providers: {
      comingSoon: 'Sắp ra mắt',
    },
    zalo: {
      connect: {
        title: 'Kết nối Zalo OA',
        description: 'Kết nối Official Account Zalo để giao tiếp với khách hàng',
        step1: 'Nhấn nút "Kết nối"',
        step2: 'Đăng nhập Zalo và cấp quyền truy cập OA',
        step3: 'Sau khi xác thực thành công, các cuộc trò chuyện sẽ tự động xuất hiện',
        button: 'Kết nối Zalo OA',
      },
      noOA: {
        title: 'Zalo OA chưa kết nối',
        description: 'Kết nối Official Account Zalo để xem cuộc trò chuyện với khách hàng',
        connectButton: 'Kết nối Zalo OA',
      },
      noChat: {
        title: 'Không có cuộc trò chuyện Zalo',
        description: 'Chưa có cuộc trò chuyện với khách hàng này qua Zalo',
      },
    },
    // DEV-2418: số WhatsApp Business dùng chung — lỗi gửi tin và cuộc gọi đến
    whatsapp: {
      sharedLine: 'Số điện thoại chung của công ty',
      sendFailed: {
        payment_required:
          'Chưa gửi tin nhắn: số dư WhatsApp Business (360dialog) đã hết. Hãy báo quản trị viên',
        generic: 'Không gửi được tin nhắn',
      },
      call: {
        incoming: 'Cuộc gọi WhatsApp đến',
        openClient: 'Mở hồ sơ khách hàng',
        declineHint: 'Người gọi sẽ biết cuộc gọi đã bị từ chối',
      },
    },
    telegram: {
      comingSoon: {
        title: 'Telegram — Sắp ra mắt',
        description: 'Tính năng tích hợp Telegram đang được phát triển',
      },
      notConnected: {
        title: 'Chưa kết nối Telegram',
        description:
          'Kết nối tài khoản Telegram của bạn để trò chuyện với khách hàng ngay trong CRM',
        connectButton: 'Kết nối Telegram',
      },
      // DEV-1712: chưa đọc được trạng thái — nói "chưa kết nối" là phỏng đoán.
      statusUnknown: {
        title: 'Không rõ trạng thái Telegram',
        description:
          'Không kiểm tra được tài khoản đã kết nối hay chưa. Hãy thử lại — tài khoản có thể vẫn đang hoạt động.',
      },
      // DEV-2109: thẻ hoạt động theo quyền read_all kể cả khi chưa có phiên cá nhân
      personalOffline: {
        title: 'Telegram cá nhân chưa được kết nối',
        hint: 'Chat của bạn không khả dụng; chat hỗ trợ và đồng nghiệp vẫn mở',
      },
      clientChatsFailed: 'Không tải được chat của khách hàng với các quản lý khác',
      supportOffline: 'Tài khoản hỗ trợ hiện chưa kết nối — tin nhắn sẽ không được gửi',
      // DEV-2109: gửi thất bại — trước đây bong bóng chỉ biến mất
      sendFailed: {
        not_connected: 'Chưa gửi tin nhắn: tài khoản Telegram chưa kết nối',
        unknown_peer: 'Chưa gửi tin nhắn: hội thoại chưa được mở trong Telegram',
        flood: 'Telegram yêu cầu chờ {seconds} giây — tin nhắn chưa gửi',
        generic: 'Không gửi được tin nhắn',
      },
      // DEV-1712: đăng nhập dang dở, phiên bị thu hồi và lần thử thất bại là
      // các trạng thái khác nhau, không phải «tài khoản chưa kết nối».
      state: {
        pendingQr: {
          title: 'Đăng nhập Telegram chưa hoàn tất',
          description: 'Mã QR chưa được quét. Không thể tiếp tục lần thử đó.',
        },
        passwordNeeded: {
          title: 'Đăng nhập Telegram đang chờ mật khẩu 2FA',
          description: 'Không thể tiếp tục lần thử trước — phải bắt đầu đăng nhập lại.',
        },
        revoked: {
          title: 'Phiên Telegram đã bị thu hồi',
          description: 'Tài khoản vẫn được liên kết — hãy đăng nhập lại bằng mã QR.',
        },
        failed: {
          title: 'Lần kết nối gần nhất đã thất bại',
          description: 'Tài khoản Telegram chưa kết nối. Hãy bắt đầu kết nối lại.',
        },
        actions: {
          restart: 'Bắt đầu lại',
          relogin: 'Đăng nhập lại',
        },
      },
      login: {
        title: 'Kết nối Telegram',
        generating: 'Đang tạo mã QR…',
        qrAlt: 'Mã QR đăng nhập Telegram',
        step1: 'Mở Telegram trên điện thoại',
        step2: 'Cài đặt → Thiết bị → Liên kết thiết bị',
        step3: 'Hướng camera vào mã QR này',
        expiresIn: 'Mã làm mới sau {seconds} giây',
        expired: 'Mã QR đã hết hạn',
        refresh: 'Làm mới mã',
        success: 'Đã kết nối Telegram',
        connectedAs: 'Đã đăng nhập với tên {name}',
        twoFa: {
          description:
            'Tài khoản được bảo vệ bằng mật khẩu đám mây (2FA). Nhập để hoàn tất đăng nhập.',
          label: 'Mật khẩu đám mây',
          placeholder: 'Nhập mật khẩu',
          submit: 'Tiếp tục',
          wrongPassword: 'Sai mật khẩu. Vui lòng thử lại.',
        },
        error: {
          title: 'Không thể kết nối',
          generic: 'Đã có lỗi xảy ra. Vui lòng thử lại.',
          // DEV-1712: lớp phiên lưu mã lỗi, giao diện chọn văn bản.
          loginExpired: 'Lần đăng nhập đã hết hạn. Hãy quét mã mới.',
          alreadyConnected: 'Tài khoản đã được kết nối — hãy ngắt phiên hiện tại trước.',
          unavailable: 'Telegram hiện không khả dụng. Vui lòng thử lại sau.',
          logoutFailed: 'Không thể ngắt kết nối tài khoản. Vui lòng thử lại.',
          statusFailed: 'Không thể kiểm tra trạng thái tài khoản. Vui lòng thử lại.',
          retry: 'Thử lại',
        },
      },
      session: {
        account: 'Tài khoản Telegram',
        allChats: 'Tất cả trò chuyện',
        disconnect: 'Ngắt kết nối',
        confirmDisconnect: 'Ngắt kết nối tài khoản?',
      },
      status: {
        inactive: 'Chưa kết nối',
        pending_qr: 'Đang chờ đăng nhập',
        password_needed: 'Cần mật khẩu 2FA',
        active: 'Trực tuyến',
        revoked: 'Phiên đã bị thu hồi',
        error: 'Lỗi',
      },
      typing: 'đang nhập…',
      noChat: {
        title: 'Không tìm thấy cuộc trò chuyện',
        description:
          'Khách hàng không có username hay số điện thoại Telegram khớp với cuộc trò chuyện, hoặc chưa có tin nhắn nào.',
      },
      picker: {
        searchPlaceholder: 'Tìm cuộc trò chuyện theo tên hoặc số điện thoại',
        listLabel: 'Danh sách trò chuyện Telegram',
        emptyTitle: 'Không tìm thấy cuộc trò chuyện',
        emptyDescription: 'Bắt đầu trò chuyện trên Telegram và nó sẽ hiển thị ở đây',
        bound: 'Đã liên kết với khách hàng này',
        bind: 'Liên kết',
        bindSuccess: 'Đã liên kết cuộc trò chuyện với khách hàng',
        bindError: 'Không thể liên kết cuộc trò chuyện',
      },
      call: {
        start: 'Gọi',
        panelTitle: 'Cuộc gọi',
        empty: 'Chưa có cuộc gọi',
        loadError: 'Không tải được cuộc gọi',
        unknownPeer: 'Liên hệ',
        accept: 'Nghe máy',
        decline: 'Từ chối',
        cancel: 'Hủy',
        mute: 'Tắt tiếng',
        hangup: 'Kết thúc',
        today: 'Hôm nay',
        expand: 'Mở rộng',
        collapse: 'Thu gọn',
        close: 'Đóng',
        outgoingCall: 'Cuộc gọi đi',
        incomingCall: 'Cuộc gọi đến',
        endedTitle: 'Cuộc gọi đã kết thúc',
        recording: 'Bản ghi',
        transcript: 'Bản chép lời',
        aiSummary: 'Tóm tắt AI',
        nextSteps: 'Bước tiếp theo',
        noRecording: 'Không có bản ghi',
        transcriptPending: 'Đang chuẩn bị bản chép lời…',
        transcriptNone: 'Không có bản chép lời',
        state: {
          connecting: 'Đang kết nối…',
          ringing: 'Đang gọi…',
          active: 'Đang gọi',
          incoming: 'Cuộc gọi đến',
        },
        recStatus: {
          ready: 'bản ghi đã sẵn sàng',
          processing: 'đang xử lý bản ghi…',
          failed: 'không có bản chép lời',
        },
        qual: {
          hot: 'Hot',
          warm: 'Warm',
          cold: 'Cold',
        },
        speaker: {
          manager: 'Quản lý',
          client: 'Khách hàng',
        },
        error: {
          generic: 'Cuộc gọi thất bại',
          mic_denied: 'Không có quyền truy cập micro',
          busy: 'Đang có cuộc gọi khác',
          ws_disconnected: 'Mất kết nối máy chủ',
          webrtc_error: 'Lỗi kết nối',
          connection_failed: 'Mất kết nối',
        },
      },
    },
  },
  agencyBot: {
    title: 'Bot hỗ trợ đại lý',
    desc: 'Nhận thông báo về yêu cầu của đại lý kèm nút «Nhận / Đóng / Chuyển».',
    connect: 'Kết nối bot',
    instructions: 'Mở bot và nhấn Bắt đầu — cuộc trò chuyện sẽ tự liên kết.',
    openBot: 'Mở bot',
    codeExpires: 'Liên kết có hiệu lực trong 15 phút.',
  },
  profile: {
    title: 'Hồ sơ',
    changeAvatar: 'Thay đổi ảnh đại diện',
    telegram: {
      title: 'Tài khoản Telegram',
      account: 'Tài khoản Telegram',
      notConnected: 'Chưa liên kết tài khoản Telegram. Kết nối để nhắn tin cho khách hàng từ CRM.',
      connect: 'Kết nối Telegram',
      change: 'Đổi',
      disconnect: 'Ngắt kết nối',
      confirmDisconnect: 'Ngắt kết nối tài khoản?',
    },
    personalInfo: 'Thông tin cá nhân',
    name: 'Tên',
    email: 'Email',
    role: 'Vai trò',
    timezone: 'Múi giờ',
    timezonePlaceholder: 'Chọn múi giờ',
    save: 'Lưu',
    saved: 'Đã lưu',
    noChanges: 'Không có thay đổi',
    languages: 'Ngôn ngữ',
    password: {
      title: 'Đổi mật khẩu',
      current: 'Mật khẩu hiện tại',
      new: 'Mật khẩu mới',
      confirm: 'Nhập lại mật khẩu mới',
      submit: 'Đổi mật khẩu',
      done: 'Đã đổi mật khẩu',
      tooShort: 'Mật khẩu phải có ít nhất 8 ký tự',
      mismatch: 'Mật khẩu không khớp',
      wrongOld: 'Mật khẩu hiện tại không đúng',
      failed: 'Không thể đổi mật khẩu. Vui lòng thử lại.',
    },
  },
  agentsRegistry: {
    title: 'Đại lý',
    comingSoon: 'Mục «Công ty» sắp ra mắt (DEV-478)',
    soon: 'sắp có',
    notAssigned: 'Chưa phân công',
    privateAgent: 'Đại lý cá nhân',
    searchPlaceholder: 'Tìm theo tên, điện thoại, công ty…',
    tabs: { agents: 'Đại lý', companies: 'Công ty' },
    filters: {
      status: 'Trạng thái',
      responsible: 'Phụ trách',
      registeredRange: 'Ngày đăng ký',
    },
    columns: {
      fullName: 'Tên đại lý',
      company: 'Công ty',
      country: 'Quốc gia',
      status: 'Trạng thái',
      offer: 'Hợp đồng',
      model: 'Mô hình',
      clients: 'KH',
      deals: 'GD',
      responsible: 'Phụ trách',
    },
    status: {
      candidate: 'Ứng viên',
      pending_offer: 'Chờ hợp đồng',
      new_partner: 'Đối tác mới',
      onboarding: 'Đang tiếp nhận',
      active: 'Hoạt động',
      dormant: 'Tạm ngưng',
      blocked: 'Bị chặn',
      archived: 'Lưu trữ',
    },
    offer: {
      not_sent: 'Chưa gửi',
      sent: 'Đã gửi',
      accepted: 'Đã chấp nhận',
      needs_reacceptance: 'Cần xác nhận lại',
      rejected: 'Từ chối',
      suspended: 'Tạm dừng',
    },
    markers: {
      companyUnconfirmed: 'Công ty chưa xác nhận',
      offerNotAccepted: 'Chưa chấp nhận hợp đồng',
      specialTerms: 'Điều khoản đặc biệt',
      checkShort: 'kiểm tra',
    },
    empty: {
      title: 'Không tìm thấy đại lý',
      withFilters: 'Không có kết quả cho bộ lọc đã chọn',
      noAgents: 'Chưa có đại lý nào',
    },
    actions: {
      addAgent: 'Thêm đại lý',
      reset: 'Đặt lại bộ lọc',
      addTask: 'Tạo nhiệm vụ',
    },
    agentRole: 'Đại lý',
    tabs2: {
      overview: 'Tổng quan',
      clients: 'Khách hàng',
      deals: 'Giao dịch',
      reward: 'Thù lao',
      offer: 'Hợp đồng',
      tasks: 'Nhiệm vụ',
      history: 'Lịch sử',
    },
    kpi: {
      clientsTransferred: 'Khách đã chuyển',
      transferredNote: 'tổng của đại lý',
      activeDeals: 'Giao dịch đang hoạt động',
      deposits: 'Đặt cọc',
      rewardForecast: 'Dự kiến thù lao',
    },
    assignment: {
      auto_matched: 'Tự động khớp',
      manual_confirmed: 'Đã xác nhận',
      requires_verification: 'Cần kiểm tra',
      private_agent_confirmed: 'Đại lý cá nhân',
      unknown: '—',
    },
    detail: {
      contacts: 'Liên hệ',
      commercial: 'Điều khoản thương mại',
      phone: 'Điện thoại',
      responsible: 'Phụ trách',
      source: 'Nguồn',
      agentClients: 'Khách của đại lý',
      allClients: 'Tất cả khách',
      companyAndSource: 'Công ty & nguồn',
      confirmation: 'Xác nhận',
      coordinator: 'Điều phối viên',
      client: 'Khách hàng',
      date: 'Ngày',
      deal: 'Giao dịch',
      openDeal: 'Mở',
      noClients: 'Đại lý chưa có khách hàng',
      clientsStageHint: 'Giai đoạn và bước tiếp theo lấy từ giao dịch (read-model, DEV-482).',
      offerBlock: 'Hợp đồng',
      status: 'Trạng thái',
      version: 'Phiên bản',
      acceptedAt: 'Ngày chấp nhận',
      rewardPercent: 'Phần trăm',
      validTo: 'Có hiệu lực đến',
      rewardForecast: 'Dự kiến thù lao',
      degraded482: '— (read-model, DEV-482)',
      dealsSoonTitle: 'Giao dịch của khách',
      dealsSoon:
        'Sẽ có sau khi read-model được điền (DEV-482) và giao dịch được liên kết với đại lý.',
      tasksSoonTitle: 'Nhiệm vụ đại lý',
      tasksSoon: 'Sẽ có ở Giai đoạn 2 (agent_tasks).',
      notFound: 'Không tìm thấy đại lý',
    },
    form: {
      email: 'Email',
      fullName: 'Họ tên',
      phone: 'Điện thoại',
      company: 'Công ty',
      companyPlaceholder: 'Chọn công ty',
      responsible: 'Phụ trách',
      language: 'Ngôn ngữ',
      country: 'Quốc gia',
      city: 'Thành phố',
      comment: 'Ghi chú',
      created: 'Đã tạo đại lý',
      createError: 'Không thể tạo đại lý',
    },
  },
  partnerCompanies: {
    title: 'Công ty đối tác',
    searchPlaceholder: 'Tìm theo tên công ty…',
    system: 'Hệ thống',
    actions: { addCompany: 'Thêm công ty' },
    filters: { status: 'Trạng thái', type: 'Loại' },
    columns: {
      name: 'Tên',
      type: 'Loại',
      status: 'Trạng thái',
      agreement: 'Hợp đồng',
      agents: 'Đại lý',
      clients: 'Khách hàng',
      model: 'Mô hình',
      responsible: 'Phụ trách',
    },
    status: {
      new: 'Mới',
      active: 'Hoạt động',
      dormant: 'Tạm ngưng',
      blocked: 'Bị chặn',
      archived: 'Lưu trữ',
      requires_verification: 'Cần kiểm tra',
    },
    type: {
      agency: 'Đại lý',
      brokerage: 'Môi giới',
      developer_partner: 'Đối tác CĐT',
      private_agent: 'Đại lý cá nhân',
      other: 'Khác',
    },
    agreement: {
      not_started: 'Chưa bắt đầu',
      sent: 'Đã gửi',
      signed: 'Đã ký',
      expired: 'Hết hạn',
      suspended: 'Tạm dừng',
      terminated: 'Đã chấm dứt',
    },
    empty: {
      title: 'Không tìm thấy công ty',
      withFilters: 'Không có kết quả cho bộ lọc đã chọn',
      noCompanies: 'Chưa có công ty nào',
    },
    tabs: {
      overview: 'Tổng quan',
      contacts: 'Liên hệ & điều phối',
      agents: 'Đại lý',
      clientsDeals: 'Khách & giao dịch',
      documents: 'Tài liệu',
      reports: 'Báo cáo',
    },
    kpi: {
      agents: 'Đại lý',
      agentsNote: 'thuộc công ty',
      clients: 'Khách hàng',
      activeDeals: 'Giao dịch đang hoạt động',
      rewardForecast: 'Dự kiến thù lao',
    },
    detail: {
      agreement: 'Hợp đồng đối tác',
      responsible: 'Phụ trách',
      document: 'Tài liệu',
      docsSoon: 'Tài liệu sẽ có sau.',
      website: 'Website',
      contract: 'Hợp đồng',
      defaultModel: 'Mô hình mặc định',
      companyAgents: 'Đại lý của công ty',
      agent: 'Đại lý',
      noAgents: 'Công ty chưa có đại lý',
      coordinator: 'Điều phối viên đối tác',
      role: 'Chức vụ',
      contractTerms: 'Hợp đồng & điều khoản',
      signedAt: 'Ngày ký',
      signedShort: 'đã ký',
      clientsDealsTitle: 'Khách & giao dịch của công ty',
      documentsTitle: 'Tài liệu công ty',
      reportsTitle: 'Báo cáo công ty',
      reportsSoon: 'Sẽ có trong analytics (Giai đoạn 2).',
      notFound: 'Không tìm thấy công ty',
    },
    form: {
      name: 'Tên công ty',
      typePlaceholder: 'Chọn loại',
      modelPlaceholder: 'Chưa đặt',
      created: 'Đã tạo công ty',
      createError: 'Không thể tạo công ty',
    },
    autocomplete: {
      minChars: 'Nhập tối thiểu 3 ký tự',
      noResults: 'Không tìm thấy',
    },
  },
  agents: {
    portalTitle: 'Cổng đại lý',
    logout: 'Đăng xuất',
    cabinet: {
      submitClient: 'Gửi khách hàng',
      more: 'Thêm',
      menu: {
        sections: 'Mục',
        settings: 'Cài đặt',
        language: 'Ngôn ngữ',
        profileSub: 'Hợp đồng, mô hình, phụ trách',
        educationSub: '5 chiến lược VINPROP',
        supportSub: 'Cuộc họp, câu hỏi, FAQ',
      },
      onboarding: {
        skip: 'Bỏ qua',
        back: 'Quay lại',
        start: 'Bắt đầu',
        next: 'Tiếp tục',
        welcome: {
          title: 'Chào mừng đến với VINPROP',
          text: 'Đây là văn phòng đại lý của bạn. Qua 5 bước, ta sẽ thiết lập: hợp đồng, hồ sơ, công ty — rồi có thể gửi khách hàng.',
        },
        offer: {
          title: 'Đã chấp nhận hợp đồng',
          text: 'Bạn đã chấp nhận hợp đồng khi đăng ký — nội dung và phiên bản luôn có trong mục «Hồ sơ và công ty».',
        },
        profile: {
          title: 'Hồ sơ của bạn',
          text: 'Liên hệ, ngôn ngữ và múi giờ ở mục «Hồ sơ và công ty». Điều khoản hoa hồng do quản lý VINPROP cấu hình.',
        },
        company: {
          title: 'Công ty đối tác',
          text: 'Công ty và người phụ trách của bạn được gắn trong hồ sơ. Mọi thắc mắc xin gửi qua «Hỗ trợ».',
        },
        done: {
          title: 'Đã xong!',
          text: 'Văn phòng đã sẵn sàng. Hãy gửi khách hàng — chúng tôi sẽ chốt giao dịch và ghi nhận hoa hồng.',
          submit: 'Gửi khách hàng',
          toCabinet: 'Vào văn phòng',
        },
      },
      searchPlaceholder: 'Tìm khách hàng, giao dịch…',
      soon: 'sắp có',
      nav: {
        dashboard: 'Bảng điều khiển',
        clients: 'Khách hàng của tôi',
        deals: 'Giao dịch của tôi',
        projects: 'Dự án',
        reward: 'Thù lao',
        education: 'Đào tạo',
        profile: 'Hồ sơ & công ty',
        support: 'Hỗ trợ',
      },
      projects: {
        title: 'Dự án',
        searchPlaceholder: 'Tìm theo tên dự án…',
        availableCount: 'Có sẵn cho bạn: {count}',
        statusOnSale: 'Đang bán',
        statusHandedOver: 'Đã bàn giao',
        details: 'Chi tiết',
        submitClient: '+ Gửi khách hàng',
        emptyTitle: 'Chưa có dự án khả dụng',
        emptyText: 'Dự án sẽ xuất hiện ở đây khi quản lý VINPROP mở quyền truy cập cho bạn.',
        contactSupport: 'Liên hệ hỗ trợ',
        errorTitle: 'Không tải được dự án',
        errorText: 'Vui lòng thử tải lại trang sau.',
        about: 'Về dự án',
        units: 'Căn hộ & giá',
        unitType: 'Loại',
        unitArea: 'Diện tích',
        unitPrice: 'Giá từ',
        materials: 'Tài liệu cho khách hàng',
        presentation: 'Bài thuyết trình',
        download: 'Tải xuống',
        ctaTitle: 'Làm việc với dự án này',
        ctaText:
          'Gửi khách hàng cho dự án này — quản lý VINPROP sẽ chốt giao dịch và ghi nhận thù lao của bạn.',
      },
      dashboard: {
        greeting: 'Xin chào, {who}',
        onboardingTitle: 'Hoàn tất thiết lập hồ sơ',
        onboardingText: 'Xác nhận công ty, tìm hiểu chiến lược và gửi khách hàng đầu tiên.',
        onboardingContinue: 'Tiếp tục',
        onboardingHide: 'Ẩn',
        kpi_clients: 'Khách đã gửi',
        kpi_deals: 'Giao dịch đang hoạt động',
        kpi_deposits: 'Đặt cọc',
        kpi_reward: 'Thù lao dự kiến',
        kpiClientsHint: 'tổng đã gửi',
        kpiDealsHint: '{n} đang đặt cọc',
        kpiDepositsHint: 'đã đặt cọc',
        kpiRewardHint: 'theo giao dịch đang hoạt động',
        nextSteps: 'Bước tiếp theo',
        noTasks: 'Không có nhiệm vụ sắp tới',
        recentDeals: 'Giao dịch gần đây',
        allDeals: 'Tất cả giao dịch',
        noDeals: 'Chưa có giao dịch',
      },
      clients: {
        searchPlaceholder: 'Tìm theo tên',
        colClient: 'Khách hàng',
        colSource: 'Nguồn',
        colStatus: 'Trạng thái',
        colNextStep: 'Bước tiếp theo',
        nextStepInline: 'Bước tiếp theo: {step}',
        colDeal: 'Giao dịch',
        dealOpen: 'Mở',
        loading: 'Đang tải…',
        empty: 'Chưa có khách hàng đã gửi',
      },
      clientStatus: {
        new: 'Mới',
        in_progress: 'Đang xử lý',
        deposit_paid: 'Đặt cọc',
        won: 'Đã chốt',
        closed: 'Đã đóng',
      },
      nextStep: {
        manager_contact: 'Quản lý sẽ liên hệ',
        manager_in_progress: 'Quản lý đang xử lý',
        deal_closing: 'Đang chốt giao dịch',
        completed: 'Hoàn tất',
      },
      deals: {
        searchPlaceholder: 'Tìm theo giao dịch, khách',
        selectHint: 'Chọn giao dịch để tiếp tục',
        colDeal: 'Giao dịch',
        colClient: 'Khách hàng',
        colStage: 'Giai đoạn',
        colDeposit: 'Đặt cọc',
        colForecast: 'Dự kiến',
        colPayoutDate: 'Ngày chi trả',
        colPayoutStatus: 'Trạng thái chi trả',
        depositYes: 'Đã nộp',
        depositNo: 'Chưa',
        empty: 'Chưa có giao dịch',
      },
      reward: {
        forecast: 'Thù lao dự kiến',
        forecastHint: 'theo giao dịch đang hoạt động',
        approved: 'Đã duyệt',
        approvedHint: 'sẵn sàng chi trả',
        paid: 'Đã thanh toán',
        paidHint: 'tổng cộng',
        empty: 'Chưa có thù lao',
      },
      rewardStatus: {
        expected: 'Dự kiến',
        approved: 'Đã duyệt',
        paid: 'Đã thanh toán',
        unavailable: 'Không áp dụng',
      },
      education: {
        strategiesTitle: 'Chiến lược đầu tư VINPROP',
        strategiesSubtitle:
          'Hãy xem cả 5 chiến lược trước khi làm việc với khách hàng — giúp xác định nhu cầu chính xác hơn.',
        watchYoutube: 'xem trên YouTube',
        webinarsTitle: 'Hội thảo trực tuyến',
        webinarsEmpty: 'Chưa có hội thảo nào',
        register: 'Đăng ký',
        registered: 'Đã đăng ký',
        watchRecording: 'Bản ghi',
        materialsTitle: 'Tài liệu cho đại lý',
        materials: {
          presentations: 'Bài thuyết trình dự án',
          pricelists: 'Bảng giá',
          recordings: 'Bản ghi hội thảo',
          instructions: 'Hướng dẫn & quy định',
        },
      },
      profile: {
        agentTitle: 'Hồ sơ đại lý',
        agentRole: 'Đại lý',
        phone: 'Điện thoại',
        email: 'Email',
        whatsapp: 'WhatsApp',
        telegram: 'Telegram',
        location: 'Quốc gia / thành phố',
        timezone: 'Múi giờ',
        language: 'Ngôn ngữ',
        lang: { ru: 'Tiếng Nga', en: 'Tiếng Anh', vn: 'Tiếng Việt' },
        statusValue: {
          active: 'Active',
          pending: 'Đang xét',
          blocked: 'Bị khoá',
          inactive: 'Không hoạt động',
        },
        offerTitle: 'Chào giá & mô hình',
        offerStatus: 'Trạng thái chào giá',
        offerValue: {
          accepted: 'Đã chấp nhận',
          pending: 'Chưa chấp nhận',
          sent: 'Đã gửi',
          declined: 'Đã từ chối',
        },
        offerVersion: 'Phiên bản',
        offerAcceptedAt: 'Ngày chấp nhận',
        modelTitle: 'Mô hình thù lao',
        modelValue: {
          '30_percent': '30% — chuyển khách',
          '50_percent': '50% — đồng dẫn dắt',
          special_terms: 'Điều khoản đặc biệt',
        },
        modelDesc: 'Mô tả mô hình',
        companyTitle: 'Công ty đối tác',
        company: 'Công ty',
        coordinator: 'Điều phối viên',
        coordinatorRole: 'Vai trò',
        partnerManager: 'Quản lý đối tác',
        documents: 'Tài liệu',
        offerDoc: 'Chào giá đại lý',
        partnerContract: 'Hợp đồng đối tác',
        open: 'Mở',
        changeTitle: 'Cần thay đổi mô hình hoặc thông tin?',
        changeText:
          'Quản lý VINPROP sẽ thay đổi liên hệ và điều khoản thương mại. Hãy liên hệ hỗ trợ.',
      },
      companyVerify: {
        title: 'Công ty đang được xét duyệt',
        statusRequires: 'Cần xác nhận',
        typed: 'Đã nhập: “{name}”',
        recommended: 'Đề xuất {pct}%',
        cta: 'Chọn công ty',
        privateAgent: 'Tôi là đại lý cá nhân',
        privateAgentHint: 'Tôi làm việc độc lập, không thuộc công ty.',
        loading: 'Đang tìm các phương án công ty của bạn…',
        pending: 'Đang khớp công ty của bạn — vui lòng quay lại sau.',
        noResult:
          'Không tìm thấy công ty của bạn. Hãy liên hệ người phụ trách — chúng tôi sẽ thêm thủ công.',
        confirmSuccess: 'Đã chọn công ty — đang chờ quản lý xác nhận.',
        confirmError: 'Không thể chọn công ty. Vui lòng thử lại.',
      },
      support: {
        myTickets: 'Yêu cầu của tôi',
        noTickets: 'Bạn chưa có yêu cầu nào',
        backToList: 'Về danh sách',
        threadEmpty: 'Chưa có tin nhắn',
        you: 'Bạn',
        staff: 'VINPROP',
        replyPlaceholder: 'Trả lời của bạn…',
        send: 'Gửi',
        otherQuestion: 'Câu hỏi khác',
        questionLabel: 'Câu hỏi của bạn',
        questionPlaceholder: 'Mô tả câu hỏi trong một tin nhắn…',
        sendQuestion: 'Gửi câu hỏi',
        questionSent: 'Đã gửi câu hỏi — chúng tôi sẽ trả lời trong giờ làm việc.',
        faq: 'Câu hỏi thường gặp',
        faqItems: {
          fixation: {
            q: 'Khách hàng được gán cho tôi như thế nào?',
            a: 'Khách được gán cho bạn trong 90 ngày kể từ khi chuyển; các giao dịch tính cho bạn.',
          },
          payout: {
            q: 'Khi nào trả thù lao?',
            a: 'Sau khi giao dịch đến bước chi hoa hồng VINPROP; ngày dự kiến xem ở mục Thù lao.',
          },
          duplicate: {
            q: 'Nếu khách đã có trong hệ thống thì sao?',
            a: 'Hệ thống đánh dấu trùng để kiểm tra; quản lý quyết định — theo dõi trạng thái ở Khách hàng của tôi.',
          },
          models: {
            q: 'Mô hình 30% và 50% khác nhau thế nào?',
            a: '30% — bạn chuyển khách, VINPROP dẫn dắt; 50% — đồng dẫn dắt. Quản lý đặt mô hình.',
          },
        },
      },
    },
    login: {
      title: 'Đăng nhập bảng đại lý',
      subtitle: 'Giới thiệu khách hàng, theo dõi giao dịch và hoa hồng.',
      email: 'Email',
      password: 'Mật khẩu',
      submit: 'Đăng nhập',
      forgot: 'Quên mật khẩu?',
      noAccount: 'Chưa có tài khoản?',
      register: 'Đăng ký',
      notAgent: 'Tài khoản này không phải tài khoản đại lý.',
      error: 'Email hoặc mật khẩu không đúng.',
    },
    offer: {
      back: 'Quay lại',
      version: 'Phiên bản bản chào số {version}',
    },
    register: {
      title: 'Đăng ký đối tác',
      subtitle: 'Điền thông tin để bắt đầu. Xác nhận email sau khi đăng ký.',
      backHome: 'Trang chính',
      sectionPartner: 'Thông tin đối tác',
      sectionContacts: 'Liên hệ',
      sectionSecurity: 'Bảo mật',
      stepLanguage: 'Ngôn ngữ',
      stepOffer: 'Thỏa thuận',
      stepProfile: 'Hồ sơ',
      language: 'Ngôn ngữ',
      email: 'Email',
      password: 'Mật khẩu',
      passwordHint: 'Tối thiểu 8 ký tự',
      confirmPassword: 'Nhập lại mật khẩu',
      passwordMismatch: 'Mật khẩu không khớp',
      agency: 'Đại lý',
      fullName: 'Họ và tên',
      phone: 'Điện thoại',
      country: 'Quốc gia',
      city: 'Thành phố',
      whatsapp: 'WhatsApp',
      telegram: 'Telegram',
      comment: 'Ghi chú',
      offerTitle: 'Thỏa thuận công khai',
      offerText: 'Tôi chấp nhận các điều khoản của',
      offerLink: 'thỏa thuận công khai',
      personalData: 'Tôi đồng ý cho xử lý dữ liệu cá nhân',
      dataAccuracy: 'Tôi xác nhận tính chính xác của dữ liệu đã cung cấp',
      next: 'Tiếp tục',
      back: 'Quay lại',
      submit: 'Đăng ký',
      hasAccount: 'Đã có tài khoản?',
      signIn: 'Đăng nhập',
      successTitle: 'Gần xong!',
      successText:
        'Chúng tôi đã gửi email xác nhận tới {email}. Nhấp vào liên kết trong email, sau đó đăng nhập.',
    },
    forgot: {
      title: 'Khôi phục mật khẩu',
      email: 'Email',
      submit: 'Gửi liên kết',
      sent: 'Nếu email này đã đăng ký, chúng tôi đã gửi liên kết đặt lại mật khẩu.',
      backToLogin: 'Quay lại đăng nhập',
    },
    reset: {
      title: 'Mật khẩu mới',
      password: 'Mật khẩu mới',
      confirm: 'Nhập lại mật khẩu',
      submit: 'Lưu mật khẩu',
      mismatch: 'Mật khẩu không khớp.',
      success: 'Đã đổi mật khẩu. Bạn có thể đăng nhập.',
      toLogin: 'Đăng nhập',
    },
    confirm: {
      verifying: 'Đang xác nhận email…',
      success: 'Đã xác nhận email! Bạn có thể đăng nhập.',
      error: 'Không thể xác nhận email. Liên kết không hợp lệ hoặc đã hết hạn.',
      toLogin: 'Đăng nhập',
    },
    home: {
      greeting: 'Xin chào, {name}!',
      agency: 'Đại lý: {agency}',
      submitClient: 'Đăng ký khách hàng',
      description: 'Chia sẻ liên hệ khách hàng — chúng tôi sẽ giữ họ cho bạn trong 90 ngày.',
      menuSubtitle:
        'Chọn hành động cần thiết. Mọi yêu cầu đều được ghi lại và chuyển đến nhân viên VINPROP phụ trách.',
      menuAriaLabel: 'Hành động của đại lý',
      menu: {
        partnership: {
          title: 'Hợp tác',
          subtitle: 'Điều kiện hợp tác và đăng ký đại lý',
        },
        registerClient: {
          title: 'Đăng ký khách hàng',
          subtitle: 'Chia sẻ liên hệ và giữ khách hàng cho bạn',
        },
        commission: {
          title: 'Hoa hồng',
          subtitle: 'Kiểm tra trạng thái và ngày thanh toán của giao dịch',
        },
        meeting: {
          title: 'Đặt lịch hẹn',
          subtitle: 'Yêu cầu gặp khách hàng theo giao dịch',
        },
        strategies: {
          title: 'Chiến lược bán hàng',
          subtitle: 'Video và tài liệu bán hàng',
        },
        other: {
          title: 'Câu hỏi khác',
          subtitle: 'Đặt câu hỏi cho nhân viên phụ trách',
        },
      },
      connectBot: {
        title: 'Kết nối bot Telegram',
        desc: 'Vẫn những thao tác đó ngay trong Telegram: giao dịch, hoa hồng, cuộc hẹn và câu hỏi.',
        connect: 'Kết nối bot',
        instructions:
          'Mở bot và nhấn “Bắt đầu” — tài khoản của bạn sẽ tự động được liên kết với Telegram.',
        openBot: 'Mở trong Telegram',
        copyLink: 'Sao chép liên kết',
        copied: 'Đã sao chép',
        codeExpires: 'Liên kết có hiệu lực trong 15 phút.',
        error: 'Không lấy được liên kết. Vui lòng thử lại.',
      },
    },
    partnership: {
      back: 'Trang chính',
      title: 'Hợp tác với VINPROP',
      registeredTitle: 'Bạn đã đăng ký làm đối tác VINPROP',
      registeredText: 'Chuyển đến khu vực đại lý hoặc chọn mục cần thiết trong menu.',
      toCabinet: 'Vào khu vực đại lý',
      registerClient: 'Đăng ký khách hàng',
      myDeals: 'Giao dịch của tôi',
    },
    strategies: {
      back: 'Trang chính',
      title: 'Chiến lược bán hàng',
      subtitle:
        'Bộ video về các chiến lược đầu tư chính của VINPROP. Khuyến nghị xem cả 5 video trước khi làm việc tích cực với khách hàng — giúp đánh giá yêu cầu chính xác hơn.',
      watch: 'Xem trên YouTube',
      videos: {
        v1: '1. Chiến lược tăng trưởng cấu trúc',
        v2: '2. Chiến lược vốn hóa cụm đô thị',
        v3: '3. Chiến lược thiếu hụt khách sạn',
        v4: '4. Chiến lược tập trung vốn',
        v5: '5. Chiến lược phong cách sống',
      },
      note: 'Sau khi xem, bạn sẽ xác định chính xác hơn chiến lược phù hợp với từng khách hàng và gửi yêu cầu chất lượng hơn.',
      ask: 'Đặt câu hỏi về chiến lược',
      questionLabel: 'Câu hỏi của bạn',
      questionPlaceholder: 'Mô tả câu hỏi về chiến lược trong một tin nhắn…',
      submit: 'Gửi câu hỏi',
    },
    other: {
      back: 'Trang chính',
      title: 'Câu hỏi khác',
      subtitle:
        'Mô tả câu hỏi của bạn trong một tin nhắn. Chúng tôi sẽ chuyển đến nhân viên VINPROP phụ trách.',
      label: 'Câu hỏi của bạn',
      placeholder:
        'Ví dụ: việc giữ khách hàng được xử lý thế nào nếu họ đã từng liên hệ VINPROP trước đây?',
      note: 'Yêu cầu sẽ được chuyển đến Agency Support. Người dự phòng là Head of Sales.',
      submit: 'Gửi câu hỏi',
    },
    inquiry: {
      success: {
        title: 'Đã tiếp nhận yêu cầu',
        subtitle:
          'Đã chuyển đến nhân viên VINPROP phụ trách. Chúng tôi sẽ trả lời trong giờ làm việc.',
        ticketLabel: 'Số yêu cầu',
        typeLabel: 'Loại',
        statusLabel: 'Trạng thái',
        statusNew: 'Mới',
        toHome: 'Trang chính',
      },
      types: {
        other: 'Câu hỏi khác',
        strategy_question: 'Chiến lược bán hàng',
      },
    },
    deals: {
      title: 'Giao dịch của tôi',
      subtitle: 'Các giao dịch mà bạn là đại lý. Tên khách hàng được ẩn để bảo mật.',
      back: 'Trang chính',
      clientLabel: 'Khách hàng: {name}',
      empty: {
        title: 'Chưa có giao dịch nào',
        description:
          'Đăng ký khách hàng — giao dịch sẽ xuất hiện ở đây sau khi được tạo trong CRM.',
        action: 'Đăng ký khách hàng',
      },
      error: {
        title: 'Không tải được giao dịch',
        retry: 'Thử lại',
      },
    },
    commission: {
      title: 'Câu hỏi về hoa hồng',
      subtitle: 'Chọn một giao dịch để xem ngày dự kiến thanh toán hoa hồng.',
      back: 'Trang chính',
      selectedDeal: 'Giao dịch đã chọn',
      changeDeal: 'Chọn giao dịch khác',
      dateLabel: 'Ngày dự kiến nhận hoa hồng',
      pendingTitle: 'Đang xác định ngày thanh toán',
      pendingFallback:
        'Ngày thanh toán dự kiến cho giao dịch này đang được xác định. Chúng tôi đã chuyển yêu cầu đến chuyên viên hỗ trợ giao dịch.',
      note: 'Câu hỏi về hoa hồng được chuyển đến nhân viên VINPROP phụ trách; bạn có thể kiểm tra trạng thái tại đây.',
      error: {
        title: 'Không tải được dữ liệu',
        retry: 'Thử lại',
      },
    },
    meeting: {
      title: 'Đặt lịch hẹn theo giao dịch',
      subtitle: 'Chọn giao dịch và các tùy chọn phù hợp — quản lý sẽ sắp xếp cuộc hẹn.',
      back: 'Trang chính',
      selectedDeal: 'Giao dịch đã chọn',
      changeDeal: 'Chọn giao dịch khác',
      withWhom: {
        label: 'Gặp với ai',
        client: 'Khách hàng',
        agent: 'Đại lý',
        both: 'Khách hàng + đại lý',
      },
      date: 'Ngày',
      time: 'Giờ',
      format: {
        label: 'Hình thức gặp',
        zoom: 'Zoom',
        googleMeet: 'Google Meet',
        whatsapp: 'WhatsApp',
        offline: 'Trực tiếp',
      },
      comment: 'Bình luận',
      commentPlaceholder: 'Mục đích cuộc hẹn, câu hỏi của khách…',
      submit: 'Gửi yêu cầu',
      success: {
        title: 'Đã gửi yêu cầu',
        subtitle: 'Quản lý sẽ liên hệ với bạn để xác nhận thời gian và hình thức cuộc hẹn.',
        detailsTitle: 'Chi tiết yêu cầu',
        dealLabel: 'Giao dịch',
        formatLabel: 'Hình thức',
        timeLabel: 'Thời gian mong muốn',
        toHome: 'Trang chính',
      },
      error: {
        title: 'Không tải được dữ liệu',
        retry: 'Thử lại',
      },
    },
    submit: {
      back: 'Trang chính',
      cancel: 'Huỷ',
      title: 'Thông báo khách hàng',
      subtitle: 'Giới thiệu khách hàng — họ sẽ được giữ cho bạn trong CRM.',
      clientName: 'Tên khách hàng',
      clientPhone: 'Điện thoại',
      clientEmail: 'Email',
      clientLanguage: 'Ngôn ngữ khách hàng',
      clientCountry: 'Quốc gia',
      propertyInterest: 'Quan tâm / mong muốn',
      propertyInterestPlaceholder: 'Ngân sách, khu vực, loại bất động sản, mục đích mua…',
      clientConsent: 'Khách hàng đồng ý xử lý dữ liệu cá nhân',
      dataAccuracy: 'Tôi xác nhận tính chính xác của dữ liệu đã cung cấp',
      submit: 'Giới thiệu khách hàng',
      resultCreatedTitle: 'Đã đăng ký khách hàng',
      resultDuplicateTitle: 'Đã có trong cơ sở dữ liệu',
      resultPendingTitle: 'Đã tiếp nhận yêu cầu',
      fixationTitle: 'Khách hàng đã được giữ cho bạn',
      fixationText:
        'Thời hạn giữ — đến {date}. Trong thời gian này, giao dịch với khách hàng này thuộc về bạn.',
      toHome: 'Trang chính',
      close: 'Đóng',
      another: 'Giới thiệu khách hàng khác',
    },
    validation: {
      required: 'Trường bắt buộc',
      email: 'Email không hợp lệ',
      phone: 'Số điện thoại không hợp lệ',
      selectCountryFirst: 'Vui lòng chọn quốc gia trước',
      minPassword: 'Tối thiểu 8 ký tự',
      consents: 'Bạn phải chấp nhận tất cả các thỏa thuận',
    },
    tags: {
      AGENT_LEAD: 'Đại lý',
      DUPLICATE: 'Trùng lặp',
    },
  },
  routing: {
    title: 'Định tuyến yêu cầu',
    subtitle: 'Quy tắc chuyển yêu cầu của đại lý đến ai và khi nào leo thang.',
    addRule: 'Thêm quy tắc',
    createTitle: 'Quy tắc mới',
    editTitle: 'Sửa quy tắc',
    deleteTitle: 'Xóa quy tắc',
    deleteText: 'Xóa quy tắc định tuyến “{type}”? Không thể hoàn tác.',
    saved: 'Đã lưu quy tắc',
    saveError: 'Không thể lưu quy tắc',
    deleted: 'Đã xóa quy tắc',
    empty: 'Chưa có quy tắc định tuyến',
    primaryKind: {
      role: 'Vai trò',
      user: 'Người dùng',
      dealManager: 'Quản lý giao dịch',
    },
    fields: {
      requestType: 'Loại yêu cầu',
      requestTypePlaceholder: 'commission_question, meeting_request, other…',
      primaryKind: 'Chuyển đến',
      primaryValue: 'Giá trị',
      primaryValueHint:
        'user_id cho người dùng, khóa vai trò cho vai trò; trống cho quản lý giao dịch',
      fallbackRoleKey: 'Vai trò dự phòng',
      slaMinutes: 'SLA, phút',
      condition: 'Điều kiện',
      conditionPlaceholder: 'Điều kiện JSON (tùy chọn)',
      enabled: 'Kích hoạt',
    },
  },
  reports: {
    // DEV-285. Mục «Báo cáo» trên analytics API.
    title: 'Báo cáo',
    subtitle: 'Phân tích bán hàng: doanh thu, phễu, nguồn khách, quản lý',
    empty: 'Không có dữ liệu cho kỳ này',
    // DEV-380. Tab phụ của mục «Báo cáo».
    tabs: {
      overview: 'Tổng quan',
      managers: 'Quản lý',
      sales: 'Phòng kinh doanh',
      salesFinance: 'Giao dịch và doanh thu',
    },
    sales: {
      subtitle:
        'Cơ cấu trạng thái yêu cầu, động lực dòng khách, hiệu quả nguồn và chất lượng khách từ đại lý',
      periodPlaceholder: 'Kỳ báo cáo',
      exportXlsx: 'Xuất XLSX',
      empty: 'Không có khách hàng tiềm năng trong kỳ',
      emptyDescription: 'Chọn kỳ khác hoặc chờ khách mới',
      kpiTotal: 'Tổng khách tiềm năng',
      kpiEffective: 'Còn đang xử lý',
      kpiNoDialog: 'Đóng do không liên hệ được',
      structureTitle: 'Cơ cấu trạng thái yêu cầu',
      monthsTitle: 'Động lực theo tháng',
      sourcesTitle: 'Hiệu quả nguồn',
      agentsTitle: 'Chất lượng khách từ đại lý',
      colClass: 'Nhóm',
      colLeads: 'Khách tiềm năng',
      colShare: 'Tỷ lệ',
      colMonth: 'Tháng',
      colDelta: 'Thay đổi',
      deltaBaseline: 'So sánh: {period} — {leads} yêu cầu',
      colPerDay: 'Khách/ngày',
      colSource: 'Nguồn',
      colActiveWarming: 'Đang xử lý + hâm nóng',
      colDeals: 'Giao dịch',
      colClosed: 'Đã đóng',
      colEffective: 'Hiệu quả',
      colAgentLeads: 'Khách từ đại lý',
      colInWork: 'Đang xử lý',
      colQuality: 'Chất lượng',
      colQualityDelta: 'Δ chất lượng',
      colFirstContact: 'Liên hệ đầu tiên',
      colAgency: 'Đại lý',
      colAgent: 'Môi giới',
      colContacts: 'Liên hệ',
      colTerms: 'Mức hoa hồng',
      colMeetings: 'Cuộc gặp',
      colFollowUps: 'Follow-up',
      colGeo: 'Quốc gia / thành phố',
      colRecruitStatus: 'Trạng thái tuyển',
      colCurator: 'Người phụ trách',
      colNote: 'Ghi chú',
      journalTitle: 'Nhật ký làm việc với môi giới đại lý',
      journalManager: 'Người phụ trách',
      journalEmpty: 'Chưa có môi giới',
      journalEmptyDescription: 'Không tìm thấy môi giới nào cho người phụ trách đã chọn',
      insightsTitle: 'Kết luận phân tích',
      insightsRefresh: 'Tạo lại kết luận',
      insightsEmpty: 'Chưa có kết luận cho kỳ này',
      insightsGeneratedAt: 'Tạo lúc {date}',
      insightsPeriod: 'Kỳ: {period}',
      insightsTimeout: 'Mô hình chưa kịp viết xong kết luận. Vui lòng thử lại sau một phút.',
      insightsFailed: 'Không lấy được kết luận. Vui lòng thử lại.',
      exportSettings: {
        title: 'Cài đặt xuất báo cáo',
        folder: 'Thư mục Google Drive',
        folderPlaceholder: 'https://drive.google.com/drive/folders/...',
        folderHint:
          'Thư mục phải nằm trên ổ đĩa dùng chung mà tài khoản dịch vụ VINPROP truy cập được',
        folderError: 'Không truy cập được thư mục — kiểm tra liên kết và quyền chia sẻ',
        schedule: 'Tần suất',
        scheduleDay: 'Hằng ngày',
        scheduleWeek: 'Hằng tuần',
        scheduleMonth: 'Hằng tháng',
        window: 'Khoảng dữ liệu',
        windowAll: 'Toàn bộ thời gian',
        windowMonths: '{n} tháng gần nhất',
        enabled: 'Bật xuất tự động',
        runNow: 'Xuất ngay',
        openFile: 'Mở tệp ↗',
        nextRun: 'Lần xuất tiếp theo: {date}',
        saved: 'Đã lưu cài đặt',
        started: 'Đã bắt đầu xuất',
        finished: 'Đã xuất báo cáo lên Google Drive',
        alreadyRunning: 'Đang có tiến trình xuất',
        status: {
          running: 'Đang xuất',
          success: 'Đã xuất',
          error: 'Lỗi',
        },
      },
      noSource: 'Không có nguồn',
      dataQualityTitle: 'Chất lượng dữ liệu',
      dqClosedButContacted: 'Đóng vì "không liên hệ được" nhưng đã có hội thoại',
      dqActiveWithoutDialog: 'Đang xử lý nhưng chưa có hội thoại nào',
      hints: {
        kpiTotal:
          'Tất cả khách tiềm năng được tạo trong kỳ đã chọn, theo ngày tạo hồ sơ khách. Đây là mẫu số cho mọi tỷ lệ trong báo cáo.',
        kpiEffective:
          'Khách còn đang xử lý: giao dịch + đang xử lý + hâm nóng. Số trong ngoặc là tỷ lệ trên tổng khách của kỳ.',
        kpiNoDialog:
          'Khách bị đóng với lý do "Không liên hệ được". Số trong ngoặc là tỷ lệ trên tổng khách của kỳ. Chỉ số tăng là dấu hiệu cần kiểm tra tốc độ phản hồi của nhân viên.',
        structureTitle:
          'Phân bố toàn bộ khách của kỳ theo nhóm. Nhóm được tính tự động, không nhập tay.',
        monthsTitle:
          'Dòng khách theo tháng tạo: khối lượng, mức tăng so với tháng trước và phân rã theo nhóm.',
        sourcesTitle:
          'So sánh các nguồn: mỗi nguồn mang lại bao nhiêu khách và bao nhiêu phần trăm còn đang xử lý.',
        agentsTitle:
          'Khách do đại lý giới thiệu: bao nhiêu còn đang xử lý. Tính khách có nguồn "Đại lý" — giống dòng "Đại lý" trong bảng nguồn.',
        dataQualityTitle:
          'Kiểm tra tính nhất quán: sai lệch giữa lý do đóng và thực tế liên hệ. Giá trị khác 0 nghĩa là nên kiểm tra lại các con số phía trên.',
        class:
          'Nhóm được xác định theo quy tắc khớp đầu tiên: có giao dịch đang mở hoặc đã thắng và đã liên lạc được với khách → "Giao dịch"; thẻ "Kiểm thử" hoặc "Trùng" → "Kiểm thử/trùng"; đã lưu trữ hoặc mọi giao dịch đều bị hủy hoặc thất bại → "Đã đóng"; thẻ "Hâm nóng" → "Hâm nóng"; còn lại → "Đang xử lý".',
        leads: 'Số khách thuộc nhóm này được tạo trong kỳ.',
        share: 'Tỷ lệ của nhóm trên tổng khách của kỳ.',
        month: 'Tháng tạo khách, theo ngày tạo hồ sơ khách.',
        delta:
          'Mức tăng số khách so với tháng liền trước, tính bằng phần trăm. Tháng bị cắt bởi ranh giới kỳ báo cáo được so với cùng khoảng ngày của tháng trước — nếu không, nửa tháng luôn trông như sụt giảm. Di chuột lên giá trị để xem mốc so sánh.',
        perDay:
          'Dòng khách trung bình mỗi ngày: số khách của tháng chia cho số ngày đã qua của tháng đó trong kỳ báo cáo. Với tháng hiện tại là tính đến hết hôm nay, không phải toàn bộ số ngày của tháng.',
        source:
          'Nguồn khách lấy từ danh mục. Khách không có nguồn được gom vào dòng riêng "Không có nguồn".',
        sourceLeads: 'Số khách đến từ nguồn này trong kỳ.',
        sourceShare: 'Tỷ trọng của nguồn trong tổng dòng khách của kỳ.',
        activeWarming:
          'Khách của nguồn này ở nhóm "Đang xử lý" và "Hâm nóng" — những người vẫn đang được làm việc.',
        deals: 'Khách của nguồn này có giao dịch đang mở hoặc đã thắng và đã liên lạc được.',
        closed: 'Khách của nguồn này đã lưu trữ hoặc mọi giao dịch đều bị hủy hoặc thất bại.',
        effectiveShare:
          'Giao dịch + đang xử lý + hâm nóng chia cho tổng khách của nguồn. So sánh nguồn theo chất lượng khách chứ không theo số lượng.',
        agentLeads: 'Khách trong tháng có nguồn "Đại lý".',
        inWork:
          'Trong số đó còn đang xử lý: giao dịch + đang xử lý + hâm nóng. Không tính đã đóng và kiểm thử/trùng.',
        quality:
          '"Đang xử lý" chia cho "Khách từ đại lý" của tháng. Cho thấy đại lý có mang về khách đúng mục tiêu hay không: 100% là không mất khách nào, giá trị thấp nghĩa là dòng khách rỗng.',
        qualityDelta:
          'Thay đổi chất lượng so với tháng trước, tính bằng điểm phần trăm — hiệu của hai tỷ lệ, không phải phần trăm của phần trăm.',
        journalTitle:
          'Nhật ký tuyển môi giới đại lý: ai đã được đưa vào, theo điều kiện nào và đã gặp bao nhiêu lần. Bộ lọc thời gian chỉ áp dụng cho bộ đếm cuộc gặp và follow-up — danh sách môi giới không bị cắt theo kỳ, nếu không những môi giới vào sớm hơn nhưng đang làm việc trong kỳ sẽ biến mất khỏi nhật ký.',
        firstContact:
          'Ngày môi giới xuất hiện trong hệ thống: tự đăng ký ở cabinet hoặc do quản lý tạo thẻ.',
        agency:
          'Đại lý: công ty đối tác đã xác nhận, nếu không thì tên do chính môi giới khai khi đăng ký.',
        contacts:
          'Mọi kênh liên hệ: điện thoại, WhatsApp, Telegram, Instagram. Với một số môi giới đại lý, Instagram là kênh duy nhất hoạt động.',
        terms:
          'Mô hình hợp tác: 30% — chuyển giao khách, 50% — cùng dẫn dắt, «Đặc biệt» — điều kiện riêng (hiển thị kèm phần trăm đã duyệt).',
        meetings:
          'Cuộc gặp trong kỳ: đã thực hiện / đã lên lịch. «Đã thực hiện» = task cuộc gặp đã đóng.',
        followUps:
          'Liên hệ lại trong kỳ: đã xong / đã tạo. Các task loại «Follow-up» từ thẻ môi giới.',
        recruitStatus:
          'Giai đoạn tuyển: ứng viên → chờ hợp đồng → đối tác mới → onboarding → hoạt động. Môi giới tạm nghỉ, bị khóa và lưu trữ vẫn nằm trong nhật ký để không mất lịch sử tuyển.',
        insightsTitle:
          'Kết luận do mô hình rút ra từ chính các con số của báo cáo này: biến động dòng khách, nguồn mạnh và nguồn yếu, điểm nghẽn chuyển đổi. Mô hình chỉ nhìn thấy số liệu tổng hợp — hồ sơ khách hàng không được gửi đi. Kết luận được lưu theo đúng bộ số đó: chừng nào số chưa đổi, mở lại tab sẽ nhận đúng kết luận cũ, còn "Tạo lại kết luận" yêu cầu diễn đạt lại từ đầu.',
        dqClosedButContacted:
          'Khách bị đóng với lý do "Không liên hệ được" dù trong CRM đã có tin nhắn hoặc cuộc gọi được trả lời. Lý do đóng bị ghi sai nên "Đóng do không liên hệ được" ở phần tổng hợp bị cao hơn thực tế.',
        dqActiveWithoutDialog:
          'Khách đang xử lý nhưng chưa có tin nhắn lẫn cuộc gọi được trả lời: lần liên hệ đầu tiên chưa diễn ra.',
        classes: {
          deal: 'Khách có giao dịch đang mở hoặc đã thắng, đã qua giai đoạn "Không liên lạc được". Giao dịch bị hủy hoặc thất bại không được tính. Quy tắc này được kiểm tra đầu tiên nên thẻ và lưu trữ không còn ảnh hưởng tới nhóm.',
          active:
            'Khách đang xử lý: chưa lưu trữ, không có thẻ "Hâm nóng", "Kiểm thử", "Trùng", và chưa có giao dịch hoặc giao dịch chưa qua giai đoạn "Không liên lạc được".',
          warming: 'Thẻ "Hâm nóng": khách quan tâm nhưng hoãn quyết định.',
          closed:
            'Khách đã lưu trữ (lý do đóng được chọn từ danh mục khi lưu trữ) hoặc mọi giao dịch đều bị hủy hoặc thất bại.',
          test_duplicate:
            'Thẻ "Kiểm thử" hoặc "Trùng" — hồ sơ nội bộ. Bị loại khỏi hiệu quả để không làm sai lệch thống kê.',
        },
      },
      classes: {
        deal: 'Giao dịch',
        active: 'Đang xử lý',
        warming: 'Hâm nóng',
        closed: 'Đã đóng',
        test_duplicate: 'Kiểm thử/trùng',
      },
    },
    // DEV-1882. Phiên bản trên màn hình của trang «Báo cáo và giao dịch».
    finance: {
      subtitle:
        'Kế hoạch và thực tế của tháng trong kỳ mục tiêu, động lực theo tuần và các giao dịch tạo nên doanh thu',
      month: 'Tháng',
      includeLeadership: 'Gồm giao dịch của ban lãnh đạo',
      exportXlsx: 'Xuất XLSX',
      noTarget: 'Chưa có mục tiêu cho tháng này',
      noTargetHint:
        'Kế hoạch và phần trăm sẽ bằng 0 cho đến khi đặt mục tiêu trong cài đặt báo cáo.',
      rewardsTitle: 'Thù lao trong tháng',
      weeksTitle: 'Kế hoạch — thực tế theo tuần',
      dealsTitle: 'Tổng hợp giao dịch',
      emptyDeals: 'Không có giao dịch nào có đặt cọc trong kỳ',
      emptyDealsHint: 'Giao dịch vào báo cáo theo ngày đặt cọc — hãy kiểm tra xem đã điền chưa.',
      week: 'Tuần',
      dates: 'Ngày',
      colPlan: 'Kế hoạch hoa hồng',
      colRevenue: 'Doanh thu vận hành',
      colNetRevenue: 'Doanh thu ròng',
      colCumulative: 'Luỹ kế',
      colDeposits: 'Đặt cọc',
      colClient: 'Khách hàng',
      colUnit: 'Dự án / căn',
      colDeposit: 'Đặt cọc',
      colBase: 'Cơ sở',
      colAgent: 'Đại lý',
      colManager: 'Quản lý',
      colHos: 'Trưởng phòng',
      colNet: 'Ròng',
      colOwner: 'Người phụ trách',
      colCounted: 'Tính',
      countedYes: 'Có',
      countedNo: 'Không',
      noClient: 'Không có khách hàng',
      kpi: {
        monthRevenue: 'Doanh thu vận hành, tháng',
        monthPlan: 'Kế hoạch tháng',
        monthNetRevenue: 'Doanh thu ròng, tháng',
        monthDeals: 'Giao dịch trong tháng',
        periodRevenue: 'Doanh thu trong kỳ',
        periodNetRevenue: 'Doanh thu ròng trong kỳ',
        avgCommission: 'Hoa hồng trung bình',
        excludedDeals: 'Giao dịch bị loại',
        agentReward: 'Thù lao đại lý',
        managerReward: 'Thù lao quản lý',
        hosReward: 'Thù lao trưởng phòng',
        ratesFilled: 'Đã điền tỷ lệ quản lý',
        agentsAttracted: 'Đại lý đã tiếp cận',
        agentClients: 'Khách từ đại lý',
      },
      settings: {
        title: 'Cài đặt báo cáo',
        hint: 'Tiền tệ hiển thị, tỷ giá và mục tiêu theo kỳ. Mục tiêu được chia theo tuần dựa trên số ngày nên đặt theo khoảng ngày.',
        display: 'Hiển thị',
        currency: 'Tiền tệ báo cáo',
        rate: 'Tỷ giá USD/VND',
        rateHint:
          'Mục tiêu tính bằng đô la còn doanh thu về bằng đồng — không có tỷ giá thì không so sánh được.',
        rateError: 'Tỷ giá phải là số dương',
        targets: 'Mục tiêu theo kỳ',
        noTargets: 'Chưa có mục tiêu',
        period: 'Kỳ',
        periodFrom: 'Bắt đầu kỳ',
        periodTo: 'Kết thúc kỳ',
        goal: 'Mục tiêu',
        goalUsd: 'Mục tiêu, USD',
        goalError: 'Mục tiêu phải là số dương',
        addTarget: 'Thêm mục tiêu',
        saved: 'Đã lưu cài đặt báo cáo',
      },
    },
    kpi: {
      revenue: 'Doanh thu',
      averageCheck: 'Giá trị trung bình',
      conversion: 'Chuyển đổi',
      dealsWon: 'Giao dịch thắng',
    },
    revenue: {
      title: 'Diễn biến doanh thu',
    },
    funnel: {
      title: 'Phễu bán hàng',
      dealsReached: 'Giao dịch ở giai đoạn',
      fromTop: 'Từ giai đoạn đầu',
    },
    leadSources: {
      title: 'Nguồn khách hàng',
    },
    leaderboard: {
      title: 'Bảng xếp hạng quản lý',
      manager: 'Quản lý',
      won: 'Thắng',
      lost: 'Thua',
      winRate: 'Tỷ lệ thắng',
      revenue: 'Doanh thu',
      averageCheck: 'TB/giao dịch',
      clients: 'Khách mới',
    },
    // DEV-197. Phân tích quản lý (chỉ HoS/admin).
    managerAnalytics: {
      title: 'Phân tích quản lý',
      subtitle:
        'Tham gia giao dịch theo giai đoạn, công việc của giao dịch và kết quả trong kỳ. Thắng hoặc thua được tính cho quản lý phụ trách giao dịch lúc đóng; thua là hủy sau khi đã liên lạc được với khách.',
      allManagers: 'Tất cả quản lý',
      period: 'Khoảng thời gian',
      dealsWon: 'Giao dịch thắng',
      dealsLost: 'Thua sau khi liên lạc',
      tasksCompleted: 'Công việc giao dịch hoàn thành',
      tasksOverdue: 'Công việc giao dịch quá hạn',
      tasks: 'Công việc của quản lý',
      winLoss: 'Kết quả giao dịch (Won/Lost)',
      stageParticipation: 'Tham gia theo giai đoạn',
      empty: 'Không có dữ liệu',
      emptyDescription: 'Không có dữ liệu cho bộ lọc đã chọn',
    },
  },
}
